import React from 'react';
import ListItem from "@material-ui/core/ListItem";
import Button from '@material-ui/core/Button';
import SvgIcon from '@material-ui/core/SvgIcon';
import Moment from 'moment';
import saveAs from 'file-saver';
import { notification } from 'antd';
import MaterialIcon from './../../components/MaterialIcon';
import FaceIcon from '@material-ui/icons/Face';
import Config from '../../constants/appConfig';

import SearchIcon from "@material-ui/icons/Search";
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Select from '@material-ui/core/Select';
import MenuList from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';

import GraphPer from './../../components/custom_graph/percentual';

import MapPoly from './MapAll';
import MapItem from './MapItem';
import Map3D from './map_3D/map3D';

import AddIcon from '@material-ui/icons/Add';
import tools from '../../components/util/tools';
import Progress from '../../components/Slider/progressGraph';

import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import ApplicationReportModal from './ApplicationReportModal';
import KmzModal from './KmzModal';

class TextFiltro extends React.Component {
  state = {
    filtro: '',
    new: false,
  };

  handleChange = event => {
    this.setState({ filtro: event.target.value, new: true });
  };

  limpaCampo = () => {
    this.setState({ filtro: '', new: false });
    this.props.call('');
  };

  call = () => {
    this.setState({ new: false });
    this.props.call(this.state.filtro)
  }

  render() {
    const { res } = this.props;//call,
    return (<div style={{ width: '14rem', height: '2rem', position: 'relative', margin: '.3rem 0 .5rem .2rem' }}>
      <TextField
        style={{ marginTop: '-.2rem', width: '10rem', marginLeft: '.4rem', marginRight: '-.4rem' }}
        placeholder={this.props.res.FILTRO}
        margin="normal"
        value={this.state.filtro}
        onChange={this.handleChange}
        onKeyDown={e => {
          if (e.keyCode === 13) { this.call() }
        }}
        id="campoFiltro"
      />
      {(this.state.filtro !== '' || this.state.new) &&
        <IconButton style={{ position: 'absolute', padding: '0', top: '.2rem', right: '3.6rem' }} onClick={() => this.limpaCampo()}>
          <MaterialIcon icon="clear" />
        </IconButton>
      }
      <Button style={{ marginLeft: '.8rem', marginTop: '-.2rem', paddingLeft: '1.1rem' }} className={this.state.new ? "buttonS buttonMenuAF" : this.state.filtro === '' ? "buttonS buttonMenu" : "buttonS buttonMenuOP"}
        disabled={this.state.filtro === '' && !this.state.new} onClick={event => this.call()} title={res.EDITAR_POLY}>
        <SearchIcon style={{ marginRight: '.5rem' }} />
      </Button>
    </div>)
  }
}
class EnhancedTable extends React.Component {

  changeDate = (date, days, meses) => {
    date.setDate(date.getDate() + days);
    date.setMonth(date.getMonth() + meses);
    return date;
  };

  state = {
    zoom: 1,
    referencia: 'updated',
    anchorElAdd: null,
    anchorElType: null,
    anchorElItem: null,
    anchorElDate: null,
    holderAnchorElDate: false,
    anchorEl: null,
    menuItem: null,
    menuItemList: [],
    menuItemListItem: null,
    url: { newUrl: null, viewUrl: null },
    progress: false,
    planeValues: {
      qtd_total: 0,
      qtd_sended: 0,
      qtd_received: 0,
    },
    filtro: '',
    selected: null,
    jobList: [],
    jobStatus: [],
    jobMissing: [],
    qtdJobs: 0,
    clients: [],
    customers: [],
    editPlanes: [],
    editPilots: [],
    selectedPlanes: [],
    planes: [],
    tab_type: [],
    tab_state: [],
    tab_missing: [],
    typeWindow: 'view',
    showForm: false,
    idPopUp: null,
    itensPlan: [],
    itensExe: [],
    itensAval: [],
    newFunc: false,
    loading: true,
    openListPlanes: false,
    selectedSendPlanes: [],
    selectedSendClients: [],
    bulkSendMode: false,
    selectedBulkPlans: [],
    bulkPlanAnchorEl: null,
    bulkPlanJob: null,
    pageNum: 1,

    lastElement: null,
    dateIni: this.changeDate(new Date(), 0, -12),
    dateEnd: this.changeDate(new Date(), 1, 0),
    onlinePlanes: 0,

    filters: {
      type: [
        { label: this.props.res.ORDEM_SERVICO_, value: 'serviceOrder', qtd: 0 },
        { label: this.props.res.ORÇAMENTO, value: 'budgeted', qtd: 0 },
        { label: this.props.res.APROVADO, value: 'approved', qtd: 0 },
        { label: this.props.res.TRABALHANDO, value: 'running', qtd: 0 },
        { label: this.props.res.CONCLUIDO, value: 'concluded', qtd: 0 },
        { label: this.props.res.CANCELADO, value: 'canceled', qtd: 0 },
      ],
      missing: [
        { label: this.props.res.SEM_PLANEJAMENTO, value: 'planejamento', qtd: 0 },
        { label: this.props.res.SEM_A_FINANCEIRA, value: 'appraisal', qtd: 0 },
        { label: this.props.res.SEM_A_QUALIDADE, value: 'analise', qtd: 0 },
      ],
    },
    allAlerts: [],

    anchorElSO: null,
    soMenuItem: null,
    soList: [],
    soLoading: false,
    action: null,
    showOnlineFarmMap3D: false,
    onlineFarmMapJobs: [],
    onlineFarmMapPlanes: [],
    openModules: false,
  };
  pageEnd = false;
  compartilhar = false;
  jobApplicationReportModalRef = React.createRef();
  jobApplicationKmzModalRef = React.createRef();

  newItem = {
    type: '',
    msg: this.props.res.PROCESSAR_TRABALHO_ASK,
    func: () => { }
  };

  scrollerRef = React.createRef();
  handleScroll = this.handleScroll.bind(this);

  columnData = [
    {
      id: 'title', disabled: false, disablePadding: true, showSelect: false,
      label: this.props.res.TITULO, value: (n) => (n.title), css: { borderBottom: 'none', padding: '1rem .5rem .2rem .5rem' }
    },
    {
      id: 'updated', disabled: false, dinamic: true,
      label: this.props.res.ATUALIZADO,
      dLabel: (n) => (this.state.referencia === 'created' ? this.props.res.CRIADO :
        this.state.referencia === 'updated' ? this.props.res.ATUALIZADO :
          this.state.referencia === 'started' ? this.props.res.INICIO__APLICACAO : this.props.res.FIM__APLICACAO),
      value: (n) => {
        return Moment(
          this.state.referencia === 'created' ? n.created :
            this.state.referencia === 'updated' ? n.updated :
              this.state.referencia === 'started' ? n.list_exe.length && n.list_exe[0].startDate :
                n.list_exe.length ? n.list_exe[0].endDate : ''
        ).format(this.props.res.FORMAT_DATAHORAMINSEG);
      },
      title: 'teste',
      css: { borderBottom: 'none', padding: '1rem .5rem .2rem .5rem' }
    },
    {
      id: 'client_name_an', disabled: false, disablePadding: true, showSelect: true,
      label: this.props.res.CLIENTE, value: (n) => (
        n.list_plan.length > 0 && n.list_plan[0].client ?
          n.list_plan[0].client : n.list_exe.length > 0 && n.list_exe[0].client_name ?
            n.list_exe[0].client_name : n.list_exe.length > 0 && n.list_exe[0].client ?
              n.list_exe[0].client : n.list_os && n.list_os.length > 0 &&
                n.list_os[0].serviceOrder && n.list_os[0].serviceOrder.client ?
                n.list_os[0].serviceOrder.client : null
      ), css: { borderBottom: 'none', padding: '1rem .5rem .2rem .5rem' }
    },
    {
      id: 'plane_name_an', disabled: false, disablePadding: true, showSelect: true,
      label: this.props.res.AERONAVE, value: (n) => {
        return n.list_plan.length > 0 && n.list_plan[0].plane ?
          n.list_plan[0].plane : n.list_exe.length > 0 && n.list_exe[0].plane_name ?
            n.list_exe[0].plane_name : n.list_exe.length > 0 && n.list_exe[0].plane ?
              n.list_exe[0].plane : n.list_os && n.list_os.length > 0 &&
                n.list_os[0].serviceOrder && n.list_os[0].serviceOrder.job &&
                n.list_os[0].serviceOrder.job.plane ?
                n.list_os[0].serviceOrder.job.plane : null
      }, css: { borderBottom: 'none', padding: '1rem .5rem .2rem .5rem' }
    },
    {
      id: 'pilot', disabled: false, disablePadding: true, showSelect: true,
      label: this.props.res.PILOTO, value: (n) => (
        n.list_plan.length > 0 && n.list_plan[0].pilot ?
          n.list_plan[0].pilot : n.list_exe.length > 0 && n.list_exe[0].pilot ?
            n.list_exe[0].pilot : n.list_os && n.list_os.length > 0 &&
              n.list_os[0].serviceOrder && n.list_os[0].serviceOrder.job &&
              n.list_os[0].serviceOrder.job.pilot ?
              n.list_os[0].serviceOrder.job.pilot : null
      ), css: { borderBottom: 'none', padding: '1rem .5rem .2rem .5rem' }
    },
    {//link do planejamento
      id: 'liters_pl', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.LITROS_APLICADOS_PLANEJAMENTO, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.round(tools.l_to_gal(n.list_plan.length > 0 && n.list_plan[0].liters ? n.list_plan[0].liters : 0))} ${this.props.res.GALOES}`
        } else {
          return `${(n.list_plan.length > 0 && n.list_plan[0].liters ? n.list_plan[0].liters : 0)} ${this.props.res.LITROS}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    {//link do execucao/qualidade
      id: 'liters_an', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.LITROS_APLICADOS_EXECUCAO, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.round(tools.l_to_gal(n.list_analise.length > 0 && n.list_analise[0].liters ? n.list_analise[0].liters :
            n.list_exe.length > 0 && n.list_exe[0].liters ? n.list_exe[0].liters : 0))} ${this.props.res.GALOES}`
        } else {
          return `${(n.list_plan.length > 0 && n.list_plan[0].liters ? n.list_plan[0].liters :
            n.list_exe.length > 0 && n.list_exe[0].liters ? n.list_exe[0].liters : 0)} ${this.props.res.LITROS}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    {//link do execucao/qualidade
      id: 'area_spray_an', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.AREAS_APLICADAS, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.round(tools.ha_to_ac(n.list_analise.length > 0 && n.list_analise[0].area_spray ? n.list_analise[0].area_spray :
            n.list_exe.length > 0 && n.list_exe[0].area_spray ? n.list_exe[0].area_spray : 0))} ${this.props.res.ACRES}`
        } else {
          return `${(n.list_analise.length > 0 && n.list_analise[0].area_spray ? n.list_analise[0].area_spray :
            n.list_exe.length > 0 && n.list_exe[0].area_spray ? n.list_exe[0].area_spray : 0)} ${this.props.res.HA}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    {//link do planejamento
      id: 'area_polygon_pl', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.AREAS_PLANEJADAS, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.ha_to_ac(n.list_plan.length > 0 && n.list_plan[0].area_polygon ? n.list_plan[0].area_polygon : 0).toFixed(3)} ${this.props.res.ACRES}`
        } else {
          return `${(n.list_plan.length > 0 && n.list_plan[0].area_polygon ? n.list_plan[0].area_polygon : 0).toFixed(3)} ${this.props.res.HA}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    {//link do execucao
      id: 'area_polygon_sk', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.AREAS_EXECUTADAS, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.ha_to_ac(n.list_exe.length > 0 && n.list_exe[0].area_polygon ? n.list_exe[0].area_polygon : 0).toFixed(3)} ${this.props.res.ACRES}`
        } else {
          return `${(n.list_exe.length > 0 && n.list_exe[0].area_polygon ? n.list_exe[0].area_polygon : 0).toFixed(3)} ${this.props.res.HA}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    {//link do qualidade
      id: 'area_polygon_an', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.AREAS_QUALIDADE, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.ha_to_ac(n.list_analise.length > 0 && n.list_analise[0].area_polygon ? n.list_analise[0].area_polygon : 0).toFixed(3)} ${this.props.res.ACRES}`
        } else {
          return `${(n.list_analise.length > 0 && n.list_analise[0].area_polygon ? n.list_analise[0].area_polygon : 0).toFixed(3)} ${this.props.res.HA}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    {//link do planejamento
      id: 'spray_pl', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.MEDIA_APLICACAO_PLANEJADA, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.lpha_to_gpac(n.list_plan.length > 0 && n.list_plan[0].area_spray && n.list_plan[0].liters ? (n.list_plan[0].liters / n.list_plan[0].area_spray).toFixed(3) : 0)} ${this.props.res.G_AC}`
        } else {
          return `${(n.list_plan.length > 0 && n.list_plan[0].area_spray && n.list_plan[0].liters ? (n.list_plan[0].liters / n.list_plan[0].area_spray).toFixed(3).replace('.', ',') : 0)} ${this.props.res.LHA}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    {//link do execucao/qualidade
      id: 'spray_sk', disabled: true, disablePadding: false, align: "right", showSelect: true,
      label: this.props.res.MEDIA_APLICACAO_EXECUTADA, value: (n) => {
        if (this.props.res.LINGUA === 'en-US') {
          return `${tools.lpha_to_gpac(n.list_analise.length > 0 && n.list_analise[0].area_spray && n.list_analise[0].liters ? (n.list_analise[0].liters / n.list_analise[0].area_spray).toFixed(3) :
            n.list_exe.length > 0 && n.list_exe[0].area_spray && n.list_exe[0].liters ? (n.list_exe[0].liters / n.list_exe[0].area_spray).toFixed(3) : 0)} ${this.props.res.G_AC}`
        } else {
          return `${(n.list_analise.length > 0 && n.list_analise[0].area_spray && n.list_analise[0].liters ? (n.list_analise[0].liters / n.list_analise[0].area_spray).toFixed(3) :
            n.list_exe.length > 0 && n.list_exe[0].area_spray && n.list_exe[0].liters ? (n.list_exe[0].liters / n.list_exe[0].area_spray).toFixed(3).replace('.', ',') : 0)} ${this.props.res.LHA}`
        }
      }, css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },
    /*{//link do execucao/qualidade
      id: '', disabled: true, disablePadding: false, align: "right", showSelect: false,
      label: '',
      value: (n) => (
        n.id
      ),
      css: { borderBottom: 'none', padding: '1rem 1rem .2rem .5rem' }
    },*/
  ];

  iconsColors = [
    '#f74343',//0: red
    '#adadad',//1: grey
    '#e0bc07',//2: yellow
    '#61bd11',//3: light green
    '#3a8bc9',//4: blue
    '#fa7d34',//5: orange
    '#52ab05',//6: dark green
    '#6ec2e6',
    '#84cae8',//8: Orcamento
    '#e6cc49',//9: Aprovado
    '#e68750',//10: Executando
    '#6fc920',//11: Concluído
    '#bfbfbf',//12: Cancelado
    '#a3cee1',//13: Ordem de Serviço
  ];

  filters = {
    todos: { label: this.props.res.TODOS, value: '0' },
    type: [
      { label: this.props.res.ORDEM_SERVICO_, value: 'serviceOrder', color: this.iconsColors[13], qtd: 0 },
      { label: this.props.res.ORÇAMENTO, value: 'budgeted', color: this.iconsColors[8], qtd: 0 },
      { label: this.props.res.APROVADO, value: 'approved', color: this.iconsColors[9], qtd: 0 },
      { label: this.props.res.TRABALHANDO, value: 'running', color: this.iconsColors[10], qtd: 0 },
      { label: this.props.res.CONCLUIDO, value: 'concluded', color: this.iconsColors[11], qtd: 0 },
      { label: this.props.res.CANCELADO, value: 'canceled', color: this.iconsColors[12], qtd: 0 },
    ],
    state: [
      { label: this.props.res.PLANEJADO, value: '1', color: this.iconsColors[4] },
      { label: this.props.res.PUBLICADO, value: '2', color: this.iconsColors[2] },
      { label: this.props.res.TRABALHANDO, value: '3', color: this.iconsColors[5], disabled: true },
      { label: this.props.res.RECEBIDO, value: '4', color: this.iconsColors[3] },
      { label: this.props.res.AVALIADO, value: '5', color: this.iconsColors[6] },
      { label: this.props.res.ORDEM_SERVICO_OS, value: '6', color: this.iconsColors[7], invisible: true },
      // { label: this.props.res.PREOPERACAO, value: '6', color: this.iconsColors[7], invisible: true },
      { label: this.props.res.LIXEIRA, value: '0', color: this.iconsColors[6], invisible: !this.props.profile?.includes(2) },
    ],
    missing: [
      { title: this.props.res.SEM_PLANEJAMENTO, label: this.props.res.SEM_PLANEJAMENTO, link: 'planejamento', value: '10', qtd: 0 },
      { title: this.props.res.SEM_A_FINANCEIRA_, label: this.props.res.SEM_A_FINANCEIRA, link: 'appraisal', value: '11', qtd: 0 },
      { title: this.props.res.SEM_A_QUALIDADE_, label: this.props.res.SEM_A_QUALIDADE, link: 'analise', value: '12', qtd: 0 },
    ],
  };

  handleSelectChange = event => {
    let getConfig;
    if (localStorage.getItem('config')) {
      getConfig = JSON.parse(localStorage.getItem('config'));
    } else {
      getConfig = {}
    }
    getConfig.referencia = event.target.value;
    localStorage.setItem('config', JSON.stringify(getConfig));
    this.setState({ referencia: event.target.value }, () => { this.updateList(1, true); });
  };

  setPageNum = (value) => {
    if (!this.pageEnd) {
      this.setState({ pageNum: value });
      this.updateList(value)
    }
  };

  setLastElement = (value) => {
    this.setState({ lastElement: value });
    const currentElement = value;
    const currentObserver = this.observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  };

  componentDidMount() {
    let getConfig = localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config')) : null;
    if (getConfig) {
      if (!isNaN(getConfig.zoom)) {
        this.setState({ zoom: getConfig.zoom });
      }
      if (getConfig.referencia) {
        this.setState({ referencia: getConfig.referencia }, () => {
          this.updateList(1, true);
        });
      } else {
        this.updateList(1, true);
      }
    } else {
      this.updateList(1, true);
    }
    this.updateListPlanes();
    this.updateListClients();
    this.readCustomers();
    this.readEditPlanes();
    this.readEditPilots();
    this.readCompanyOpenModules();
    //horizontal scroll div planes
    let item = document.getElementById("planes");
    item.addEventListener("wheel", (e) => {
      if (e.deltaY > 0) item.scrollLeft += 50;
      else item.scrollLeft -= 50;
    });
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  };

  setAllJobs = () => {
    this.setState({ tab_state: [], tab_missing: [], tab_type: [] }, () => this.updateList(1, true));
  };

  setNewJobs = (name, value) => {
    this.setState({ [name]: value }, () => this.updateList(1, true));
  };

  setArrJobs = (name, value) => {
    let arr = this.state[name];
    if (arr.includes(value)) {
      arr = arr.filter(item => value !== item);
    } else {
      arr.push(value);
    }
    this.setState({ [name]: arr }, () => this.updateList(1, true));
  };

  changeZoom = (value) => {
    let zoom = this.state.zoom + value;
    let getConfig;

    if (localStorage.getItem('config')) {
      getConfig = JSON.parse(localStorage.getItem('config'));
    } else {
      getConfig = {}
    }
    getConfig.zoom = zoom;
    localStorage.setItem('config', JSON.stringify(getConfig));
    this.setState({ zoom: this.state.zoom + value });
  };

  clear = () => {
    this.setState({ filtro: '' });
  };

  updateList = (page, change, id) => {
    this.setState({ loading: true });
    this.pageEnd = true;
    const size = 20;
    const filters = {
      size: size,
      page: page,
      dateini: this.state.dateIni.getTime(),
      datefim: this.state.dateEnd.getTime(),
      type: this.state.tab_type.includes('serviceOrder')
        ? [...new Set([...this.state.tab_type, 'budgeted'])]
        : this.state.tab_type,
      state: this.state.tab_state,
      missing: this.state.tab_missing,
      planes: this.state.selectedPlanes,
      id: id,
      filtro: this.state.filtro,
      referencia: this.state.referencia,
    };
    const apiUrl = `${Config.server}/job_list`;

    let options = {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(filters),
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          const isSOView = this.state.tab_type.includes('serviceOrder');
          const dataJobList = isSOView && Array.isArray(result?.data)
            ? result.data.filter(it =>
              it?.type === 'serviceOrder' ||
              (it?.type === 'budgeted' &&
                Number(it.id_service_order) > 0 &&
                Number(it.id_service_order_job) > 0)
            )
            : result.data;

          if (id && (dataJobList?.length > 0)) {
            let list = this.state.jobList;
            let index = list.findIndex(item => (item.id === id));
            let state = { loading: false };
            if (index >= 0) {
              list[index] = dataJobList[0];
              state.jobList = this.state.jobList;
            }
            this.setState(state);
          } else {
            let state = {};
            if (dataJobList?.length > 0) {
              this.pageEnd = false;
              if (change) {
                state.jobList = dataJobList;
              } else {
                let all = new Set([...this.state.jobList, ...dataJobList]);
                state.jobList = [...all];
              }
              //total de aeronaves
              state.qtdJobs = result.total;
              let total = 0;
              //total de status
              state.filters = this.state.filters;
              for (let i = 0; i < result.total_status.length; i++) {
                const element = result.total_status[i];
                let item = state.filters.type.filter(a => (a.value === element.type));
                if (item.length > 0) {
                  item[0].qtd = element.qtd;
                  if (element.type != 'budgeted' && element.type != 'canceled') {
                    total += element.qtd;
                  }
                }
              }
              //total de sem etapa
              for (let i = 0; i < result.total_missing.length; i++) {
                const element = result.total_missing[i];
                let item = state.filters.missing.filter(a => (a.value === element.type));
                if (item.length > 0 && total > 0) {
                  item[0].qtd = Math.floor(element.qtd * 100 / total);
                }
              }
            } else if (page === 1) {
              this.pageEnd = true;
              state.jobList = [];
              state.qtdJobs = 0;
            } else {
              this.pageEnd = true;
            }
            state.loading = false;
            this.setState(state, () => {
              if (page === 1) {
                this.scrollerRef.current.scrollTop = 0;
              }
            });
          }

        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  updateListStatus = () => {
    const filters = {
      dateini: this.state.dateIni.getTime(),
      datefim: this.state.dateEnd.getTime(),
    };
    const apiUrl = `${Config.server}/job_list_status`;

    let options = {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(filters),
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          let state = {};
          let total = 0;
          //total de status
          state.filters = this.state.filters;
          for (let i = 0; i < result.total_status.length; i++) {
            const element = result.total_status[i];
            let item = state.filters.type.filter(a => (a.value === element.type));
            if (item.length > 0) {
              item[0].qtd = element.qtd;
              if (element.type != 'budgeted' && element.type != 'canceled') {
                total += element.qtd;
              }
            }
          }
          //total de sem etapa
          for (let i = 0; i < result.total_missing.length; i++) {
            const element = result.total_missing[i];
            let item = state.filters.missing.filter(a => (a.value === element.type));
            if (item.length > 0 && total > 0) {
              item[0].qtd = Math.floor(element.qtd * 100 / total);
            }
          }
          this.setState(state);
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  updateListPlanes = () => {
    if (!document.getElementById('planes')) {
      return;
    }
    const apiUrl = `${Config.server}/plane_jobs/${this.state.dateIni.getTime()}/${this.state.dateEnd.getTime()}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          const planes = result.planes ? result.planes : [];
          const sources = result.sources ? result.sources : [];
          let min = 60000 * 3;//minutos de limite sem sinal

          let state = {
            planeValues: {
              qtd_total: 0,
              qtd_sended: 0,
              qtd_received: 0,
            },
          }
          let onlinePlanes = 0;
          for (let i = 0; i < planes.length; i++) {
            const item = planes[i];
            const values = {
              qtd_total: !item ? 0 : item.qtd_exe,
              qtd_sended: !item ? 0 : item.qtd_sended ? item.qtd_sended : 0,
              qtd_received: !item ? 0 : item.qtd_received ? item.qtd_received : 0,
            };
            state.planeValues = {
              qtd_total: state.planeValues.qtd_total + values.qtd_total,
              qtd_sended: state.planeValues.qtd_sended + values.qtd_sended,
              qtd_received: state.planeValues.qtd_received + values.qtd_received,
            };

            item.online = item.ping_time ? new Date() - new Date(item.ping_time) < min : false;
            if (item.online) {
              onlinePlanes++;
            }
          }
          state.onlinePlanes = onlinePlanes;
          state.planes = planes;

          let onlineSources = 0;
          for (let i = 0; i < sources.length; i++) {
            const item = sources[i];
            if (item.ping_time && new Date() - new Date(item.ping_time) < min) {
              onlineSources++;
            }
          }
          state.onlineSources = onlineSources;
          this.setState(state);
          setTimeout(() => {
            this.updateListPlanes();
          }, 60000);
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  updateListClients = () => {
    const apiUrl = Config.server + '/company_link/client';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({ clients: result });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  readCustomers = () => {
    const apiUrl = Config.server + '/customer';
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        const customers = Array.isArray(result) ? result : [];
        this.setState({ customers });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  readEditPilots = () => {
    const apiUrl = `${Config.server}/pilot`;
    const apiUrlPerm = `${Config.server}/pilot/perm`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    Promise.all([
      fetch(apiUrl, options),
      fetch(apiUrlPerm, options)
    ])
      .then((responses) => {
        for (let i = 0; i < responses.length; i++) {
          if (responses[i].status !== 200) throw responses[i];
        }
        return Promise.all(responses.map((res) => res.json()));
      })
      .then((result) => {
        const pilots = Array.isArray(result[0]) ? result[0] : [];
        const permPilots = Array.isArray(result[1]) ? result[1] : [];

        const merged = [];
        const seen = {};

        for (let i = 0; i < pilots.length; i++) {
          const pilot = pilots[i];
          if (pilot && pilot.id != null && !seen[pilot.id]) {
            seen[pilot.id] = true;
            merged.push(Object.assign({}, pilot, {
              original_name: pilot.name ? String(pilot.name) : '',
              id_company: pilot.id_company != null ? pilot.id_company : null
            }));
          }
        }

        for (let i = 0; i < permPilots.length; i++) {
          const pilot = permPilots[i];
          if (!pilot || pilot.id == null) continue;

          const pilotName = pilot.name ? String(pilot.name) : '';
          const companyName = pilot.company_name ? String(pilot.company_name) : '';

          const mergedPilot = Object.assign({}, pilot, {
            original_name: pilotName,
            name: companyName ? pilotName + ' - ' + companyName : pilotName,
            id_company: pilot.id_company != null ? pilot.id_company : null
          });

          if (!seen[pilot.id]) {
            seen[pilot.id] = true;
            merged.push(mergedPilot);
          }
        }

        this.setState({ editPilots: merged });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  readEditPlanes = () => {
    const apiUrl = `${Config.server}/plane`;
    const apiUrlPerm = `${Config.server}/plane/perm`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    Promise.all([
      fetch(apiUrl, options),
      fetch(apiUrlPerm, options)
    ])
      .then((responses) => {
        for (let i = 0; i < responses.length; i++) {
          if (responses[i].status !== 200) throw responses[i];
        }
        return Promise.all(responses.map((res) => res.json()));
      })
      .then((result) => {
        const planes = Array.isArray(result[0]) ? result[0] : [];
        const permPlanes = Array.isArray(result[1]) ? result[1] : [];

        const merged = [];
        const seen = {};

        for (let i = 0; i < planes.length; i++) {
          const planeItem = planes[i];
          if (planeItem && planeItem.id != null && !seen[planeItem.id]) {
            seen[planeItem.id] = true;
            merged.push(Object.assign({}, planeItem, {
              original_name: planeItem.name ? String(planeItem.name) : '',
              id_company: planeItem.id_company != null ? planeItem.id_company : null
            }));
          }
        }

        for (let i = 0; i < permPlanes.length; i++) {
          const plane = permPlanes[i];
          if (!plane || plane.id == null) continue;

          const planeName = plane.name ? String(plane.name) : '';
          const companyName = plane.company_name ? String(plane.company_name) : '';

          const mergedPlane = Object.assign({}, plane, {
            original_name: planeName,
            name: companyName ? planeName + ' - ' + companyName : planeName,
            id_company: plane.id_company != null ? plane.id_company : null
          });

          if (!seen[plane.id]) {
            seen[plane.id] = true;
            merged.push(mergedPlane);
          }
        }

        this.setState({ editPlanes: merged });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  normalizeCompanyOpenModules = (data) => {
    let company = data;

    if (company && company.data) {
      company = company.data;
    }

    if (Array.isArray(company)) {
      company = company.length > 0 ? company[0] : null;
    }

    if (!company) {
      return false;
    }

    const value = company.openModules !== undefined ? company.openModules :
      company.open_modules !== undefined ? company.open_modules :
        company.openModules !== undefined ? company.openModules :
          company.open_modules !== undefined ? company.open_modules : 0;

    return value === true || value === 'true' || Number(value) === 1;
  };

  readCompanyOpenModulesFromLocalStorage = () => {
    const keys = ['company', 'empresa', 'user', 'usuario', 'config'];

    for (let i = 0; i < keys.length; i++) {
      const rawValue = localStorage.getItem(keys[i]);

      if (!rawValue) {
        continue;
      }

      try {
        const data = JSON.parse(rawValue);

        if (this.normalizeCompanyOpenModules(data)) {
          return true;
        }

        if (data && data.company && this.normalizeCompanyOpenModules(data.company)) {
          return true;
        }

        if (data && data.empresa && this.normalizeCompanyOpenModules(data.empresa)) {
          return true;
        }
      } catch (_) { }
    }

    return false;
  };

  getLoggedCompanyIdFromToken = () => {
    try {
      const token = localStorage.getItem('access-token-jwt');

      if (!token) {
        return null;
      }

      const parts = token.split('.');

      if (parts.length < 2) {
        return null;
      }

      const payloadText = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
      const payload = JSON.parse(payloadText);

      return payload.id_company || payload.company_id || payload.idCompany || payload.companyId || null;
    } catch (_) {
      return null;
    }
  };

  readCompanyOpenModules = () => {
    const localStorageValue = this.readCompanyOpenModulesFromLocalStorage();

    if (localStorageValue) {
      this.setState({ openModules: true });
      return;
    }

    const companyId = this.getLoggedCompanyIdFromToken();
    const apiUrl = companyId ? `${Config.server}/company/${companyId}` : `${Config.server}/company/current`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        this.setState({ openModules: this.normalizeCompanyOpenModules(result) });
      })
      .catch(() => {
        this.setState({ openModules: false });
      });
  };

  shouldOpenModules = () => {
    return this.state.openModules === true || Number(this.state.openModules) === 1;
  };

  openAppPath = (path) => {
    if (!path) {
      return;
    }

    if (this.shouldOpenModules()) {
      const href = window.location.origin + path;
      const newWindow = window.open(href, '_blank');

      if (!newWindow) {
        this.props.link(path);
      }

      return;
    }

    this.props.link(path);
  };

  openModule = (type, guid) => {
    this.openAppPath('/app/' + type + '/' + guid);
  };

  download_relatorio_aplicacao = (id) => {
    this.setState({ progress: true });

    let apiUrl = Config.server + '/relaplicacao';
    let method = 'POST';

    let data = {
      culture: this.props.res.LINGUA,
      id: id
    };

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.blob();
      })
      .then(
        (result) => {
          this.setState({ progress: false });
          let file_name = 'APL' + Date.now() + '.pdf';
          if (result.type === 'application/pdf' && result.size > 0) {
            saveAs(result, file_name);
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  downloadJob = (job_id) => {
    if (!isNaN(job_id)) {
      let apiUrl = Config.server + '/job_download/' + job_id;
      let method = 'GET';

      let options = {
        method: method,
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.blob();
        })
        .then(
          (result) => {
            let file_name = (this.state.title_est ? this.state.title_est.replace(/[^a-z0-9_]/gi, "") : Date.now()) + '.zjob';
            saveAs(result, file_name);
          },
          (error) => {
            this.setState({ progress: false });
            if (error.status === 405) {
              notification.open({
                message: this.props.res.PERMISSAO,
                description: this.props.res.PERMISSAO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            } else if (error.status === 401 || error.status === 403) {
              console.log(error);
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
  };
  downloadJobPl = (job_id, title) => {
    this.setState({ anchorEl: null, menuItemList: [] });
    if (!isNaN(job_id)) {
      let apiUrl = `${Config.server}/job_link_download/${job_id}`;
      let method = 'GET';

      let options = {
        method: method,
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.blob();
        })
        .then(
          (result) => {
            this.setState({ progress: false });
            let file_name = 'ORC' + (title ? title.replace(/[^a-z0-9_]/gi, "") : Date.now()) + '.zjob';
            saveAs(result, file_name);
          },
          (error) => {
            this.setState({ progress: false });
            if (error.status === 405) {
              notification.open({
                message: this.props.res.PERMISSAO,
                description: this.props.res.PERMISSAO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            } else if (error.status === 401 || error.status === 403) {
              console.log(error);
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
  };

  openProcess = (type, guid, progress) => {
    if (type === 'estimativa/new' || type === 'estimativa/edit') {
      this.openModule(type, guid);
    } else if (!progress || progress < 100) {
      this.newItem.msg = this.props.res.PROCESSAR_TRABALHO_ASK;
      this.newItem.func = () => {
        this.openModule(type, guid);
      };
      this.setState({ newFunc: true });
    } else if (progress === 100) {
      this.openModule(type, guid);
    } else if (progress) {
      notification.open({
        message: progress + '%',
        icon: <MaterialIcon icon="check_circle" className="text-success" />
      });
    }
  };
  /*
    changeValue = (id, field, value) => {
      this.newItem.msg = 'Deseja processar o trabalho?';
      this.newItem.func = () => {
        this.props.link('/app/' + type + '/' + guid);
      };
      this.setState({ newFunc: true });
  
    };*/

  textItem = (key, col, item) => {
    const value = col.value(item);
    const style = col.id === 'plane_name_an' ? { marginTop: '.5rem', display: 'grid', gridTemplateColumns: 'calc(100% - 5.5rem) 5.5rem' } : { marginTop: '.5rem' };
    return <div key={key} style={style}>
      {col.dinamic ?
        <div>
          <span style={{ fontWeight: 'bold' }}>{col.dLabel()}: </span>{value ?
            <span>{value} <InfoIcon title={this.props.res.MAIS_INFORMACOES} style={{ width: '1rem', height: '1rem', cursor: 'pointer' }} onClick={(e) => (this.handlePopoverOpen(e, item))} /></span> : ' - '}
        </div> :
        <div><span style={{ fontWeight: 'bold' }}>{col.label}: </span>{value ? value : ' - '}</div>
      }
    </div>;
  };

  handlePopoverOpen = (event, item) => {
    this.setState({ anchorElDate: event.currentTarget, menuItem: item });
  };
  handlePopoverClose = () => {
    this.setState({ anchorElDate: null });
  };
  handlePopover = () => {
    this.setState({ holderAnchorElDate: true });
  };
  handlePopClose = () => {
    this.setState({ holderAnchorElDate: true }, () => {
      this.handlePopoverClose();
    });
  };

  selectItem = (item) => {
    this.setState({ selected: item });
  };

  CompJob = (key, item) => {
    item.stage = item.jl_ap > 0 ||
      item.jl_an > 0 ? 4 ://Avaliados
      item.jl_sk > 0 ? 3 ://Recebidos
        item.transfer_pl > 0 ? 1 ://Publicados
          item.jl_pl > 0 ? 0 ://Planejados
            5;//pre orcamento;
    const type = this.filters.state[item.stage];

    let temp_color = this.filters.type.filter(o => item.type === o.value);
    temp_color = temp_color.length > 0 ? temp_color[0] : this.filters.type[0];
    item.link = "contained-list-file" + item.id;

    let itensQualidade = item.jl_an > 0 && item.list_analise.filter(item => (item.progress_task === 100)).length > 0;

    let selExeItem = null;

    if (item.list_analise && item.list_analise.length > 0) {
      selExeItem = item.list_analise.filter(i => i && i.progress_task === 100 && (Number(i.area_polygon) > 0 || Number(i.area_spray) > 0))[0] ||
        item.list_analise.filter(i => i && (Number(i.area_polygon) > 0 || Number(i.area_spray) > 0))[0] ||
        null;
    }

    if ((!selExeItem || Number(selExeItem.area_polygon) <= 0) && item.list_exe && item.list_exe.length > 0) {
      selExeItem = item.list_exe.filter(i => i && i.progress_task === 100 && (Number(i.area_polygon) > 0 || Number(i.area_spray) > 0))[0] ||
        item.list_exe.filter(i => i && (Number(i.area_polygon) > 0 || Number(i.area_spray) > 0))[0] ||
        item.list_exe[0];
    }

    if (!selExeItem && item.list_analise && item.list_analise.length > 0) {
      selExeItem = item.list_analise[0];
    }
    let percente = !selExeItem ? 100 :
      (Number(selExeItem.area_polygon) === 0 && Number(selExeItem.area_spray) > 0) ? Number(selExeItem.area_spray) :
        !selExeItem.area_polygon || !selExeItem.area_spray ? 0 :
          (selExeItem.area_polygon - selExeItem.area_spray) * 100 / selExeItem.area_polygon;
    percente = 100 - percente;

    /*let selPlanItem = item.jl_pl > 0 ? item.list_transf_plan[item.list_transf_plan.length - 1] : null;
    let isSend = item.transfer_pl > 0 && (selPlanItem && selPlanItem.status === "success");
    let isReceive = item.jl_sk > 0 || (item.transfer_pl > 0 && (selPlanItem && selPlanItem.status === "DGPS success"));
    let isFail = item.jl_sk === 0 && (item.transfer_pl > 0 && (selPlanItem && selPlanItem.status === "DGPS fail"));
    let isBack = item.jl_sk > 0;*/

    let hasClimateData = (item.acceptableTemperature || item.correctTemperature || item.unacceptableTemperature ||
      item.acceptableWindSpeed || item.correctWindSpeed || item.unacceptableWindSpeed ||
      item.acceptableHumidity || item.correctHumidity || item.unacceptableHumidity ||
      item.acceptableDeltaT || item.correctDeltaT || item.unacceptableDeltaT);
    let isSend = item.transfer_pl > 0 && (item.list_transf_plan.filter(item => item.status === "success").length > 0);
    let isReceive = item.jl_sk > 0 || (item.transfer_pl > 0 && (item.list_transf_plan.filter(item => item.status === "DGPS success").length > 0));
    let isFail = item.jl_sk === 0 && (item.transfer_pl > 0 && (item.list_transf_plan.filter(item => item.status === "DGPS fail").length > 0));
    let isBack = item.jl_sk > 0;


    let shareTooltip = null;
    let shareIcon = "share";

    let thisCompanyId = (item.id_company !== null && item.id_company !== undefined)
      ? Number(item.id_company)
      : null;
    let originId = (item.id_company_origin !== null && item.id_company_origin !== undefined)
      ? Number(item.id_company_origin)
      : null;
    let sharedId = (item.id_company_shared !== null && item.id_company_shared !== undefined)
      ? Number(item.id_company_shared)
      : null;

    let shareStatus = item.share_status;

    if (item.type === 'serviceOrder') {


      if (sharedId && originId && thisCompanyId && thisCompanyId === originId) {

        if (shareStatus === 'retornado') {
          if (this.props.res._TRABALHO_RETORNADO_POR) {
            shareTooltip = tools.replaceString(this.props.res._TRABALHO_RETORNADO_POR, item.company_shared_name);
          }
          shareIcon = "reply";
        }

        else if (shareStatus === 'compartilhado') {
          shareTooltip = tools.replaceString(this.props.res._TRABALHO_COMPARTILHADO_COM, item.company_shared_name);
          shareIcon = "share";
        }
      }


      if (!shareTooltip && originId && thisCompanyId && thisCompanyId !== originId) {
        shareTooltip = tools.replaceString(this.props.res._TRABALHO_COMPARTILHADO_POR, item.company_origin_name);
        shareIcon = "share";
      }
    }


    if (!shareTooltip && item.list_exe && item.list_exe.length > 0) {
      const exeWithOrigin = item.list_exe.filter(i => i.id_company_origin !== null);
      if (exeWithOrigin.length > 0) {
        const exeOrigin = exeWithOrigin[0];
        const exeOriginId = exeOrigin.id_company_origin !== null && exeOrigin.id_company_origin !== undefined
          ? Number(exeOrigin.id_company_origin)
          : null;

        if (thisCompanyId && exeOriginId && thisCompanyId !== exeOriginId) {
          shareTooltip = tools.replaceString(this.props.res._TRABALHO_COMPARTILHADO_POR, exeOrigin.company_origin_name);
          shareIcon = "share";
        }
      }
    }

    const bulkPlans = this.getBulkPlansFromJob(item);
    const selectedBulkPlansFromJob = this.getSelectedBulkPlansFromJob(item);
    const hasBulkPlans = bulkPlans.length > 0;
    const isBulkSelected = selectedBulkPlansFromJob.length > 0;
    const isBulkIndeterminate = isBulkSelected && selectedBulkPlansFromJob.length < bulkPlans.length;
    let style1 = { height: '21rem', width: '20rem', position: 'relative' };
    if (this.state.selected === item) {
      style1.border = 'dashed 3px #858585';
    }
    if (isBulkSelected) {
      style1.border = 'solid 3px #3a8bc9';
    }
    return <div key={key} className="divContent" style={style1}>
      {this.state.bulkSendMode &&
        <div style={{ position: 'absolute', top: '-.4rem', right: '-.4rem', zIndex: 5, backgroundColor: 'white', borderRadius: '50%', boxShadow: '0 0 4px #00000055' }}>
          <Checkbox
            disabled={!hasBulkPlans}
            checked={!!isBulkSelected}
            indeterminate={!!isBulkIndeterminate}
            onClick={(event) => { this.handleBulkCardSelection(event, item); }}
            onChange={() => { }}
            title={hasBulkPlans ? this.props.res.SELECIONAR_PLANEJAMENTO : this.props.res.NENHUM_PLANEJAMENTO}
          />
        </div>
      }
      <div style={{ overflow: 'hidden', display: 'grid', position: 'relative', gridTemplateColumns: '6.5rem calc(100% - 9rem) 2.5rem', textAlign: 'center', backgroundColor: type.color, height: '2rem', borderRadius: '.2rem .2rem 0 0', margin: '-1rem -1rem 0 -1rem' }}>
        <span style={{ backgroundColor: temp_color.color, color: 'white', lineHeight: '2rem', fontWeight: 'bold', zIndex: '0', width: '7.25rem', borderRadius: '.3rem', marginLeft: '-1rem', paddingLeft: '1rem' }}>
          <ListItem button
            style={{ height: '2rem', display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap' }}
            onClick={event => { this.handleClickAdd(event, 'anchorElType', item) }}
          >
            {temp_color.label/*item.type*/}
          </ListItem>
        </span>
        <span style={{ color: 'white', lineHeight: '2rem', whiteSpace: 'nowrap', fontWeight: 'bold' }}>{('CDO-' + ("000" + (new Date(item.created).getFullYear())).slice(-3) + '-' + item.id)} - {type.label}</span>
        <ListItem button
          style={{ height: '2rem' }}
          onClick={event => { this.handleClick(event, item) }}
        >
          <h2 style={{ color: 'white', marginLeft: '-.6rem', fontWeight: 'bold', transform: 'rotate(270deg)', marginTop: '.5rem' }}>...</h2>
        </ListItem>
      </div>
      <div style={{ position: 'relative', height: '2rem', margin: '0 0 1rem', display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '15rem' }}>
          <Progress
            text={
              this.props.res.LINGUA === 'en-US' ?
                //us
                `${tools.round(tools.ha_to_ac(
                  selExeItem && selExeItem.area_spray ? selExeItem.area_spray : 0
                ), 2)}  ${this.props.res.AC} / ` +
                `${tools.round(tools.ha_to_ac(
                  selExeItem && selExeItem.area_polygon ? selExeItem.area_polygon : 0
                ), 2)} ${this.props.res.AC}`
      /* br */ :
                `${(
                  selExeItem && selExeItem.area_spray ? selExeItem.area_spray : 0
                )} ${this.props.res.HA} / ` +
                `${(
                  selExeItem && selExeItem.area_polygon ? selExeItem.area_polygon : 0
                )} ${this.props.res.HA}`
              //
            }
            isSend={isSend}
            isReceive={isReceive}
            isFail={isFail}
            percente={temp_color.value === 'concluded' ? 100 : percente < 0 ? 0 : percente > 100 ? 100 : percente}
            isBack={isBack}
          />
        </div>

        {shareTooltip && (
          <div className='.MuiImageListItemBar-title' style={{ margin: '.6rem', cursor: 'help' }} title={shareTooltip}>
            <MaterialIcon icon={shareIcon} style={{ marginTop: '.3rem', marginRight: '.2rem' }} />
          </div>
        )}
      </div>
      <div style={{ marginTop: '.5rem', height: '9rem', overflow: 'auto' }}>
        {this.columnData.map((col, i) => (
          this.textItem(i, col, item)
        ))}
      </div>
      <div style={{ marginTop: '1rem', textAlign: 'center' }}>
        {/* <Button className="buttonS textButtom" style={{ paddingLeft: '1.1rem', backgroundColor: this.iconsColors[item.id_job_po ? 3 : 4] }} onClick={event => (this.props.link('/app/preoperacao/' + item.guid))}
          title={this.props.res.PREOPERACAO}>
          <MaterialIcon icon="description" className="iconS icon-pos iconMenu" />
        </Button> */}
        <Button
          className="buttonS textButtom"
          style={{ paddingLeft: '1.1rem', position: 'relative', backgroundColor: this.iconsColors[item.id_service_order_job ? 3 : 4] }}
          onClick={(event) => this.openServiceOrderMenu(event, item)}
          title={this.props.res.ORDEM_SERVICO}
        >
          <MaterialIcon icon="description" className="iconS icon-pos iconMenu" />
        </Button>
        <Button className="buttonS textButtom" style={{ paddingLeft: '1.1rem', backgroundColor: this.iconsColors[item.jl_an > 0 ? 3 : 4] }} onClick={event => (this.openPoly(item.id))}
          title={this.props.res.INCLUSAO_AREAS}>
          <div style={{ marginTop: '.5rem' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="-20 -50 400 400">
              <path d="M 18.58 229.62 L 18.12 81.95 L 73.01 50.26 C 76.57 47.9 80.22 48 83.94 50.44 L 134.65 78.97 C 136.97 80.74 139.43 80.93 142.04 79.07 L 161.09 67.35 C 161.6 69.84 162.37 72.39 163.39 75.03 C 165.45 80.34 168.22 84.69 171.07 89.32 L 171.7 90.33 L 146.73 104.48 L 146.95 196.96 L 192.39 173.3 L 192.29 124.38 L 194.04 127.27 C 195.37 129.09 197.38 130.93 198.01 131.57 C 198.11 131.48 200.16 129.77 207.84 118.18 L 208.42 117.22 L 208.42 173.34 L 236.52 189.57 L 235.96 96.92 L 224.68 90.41 C 227.79 85.24 230.69 80.09 232.24 76.06 C 233.33 73.24 234.27 70.46 234.83 67.54 L 255.75 79.61 L 255.75 227.32 L 202.43 195.85 C 200.33 194.58 198.31 194.55 196.35 195.77 L 142.9 226.64 C 140.1 228.04 137.31 228.1 134.52 226.52 L 82.85 197.53 C 79.99 195.81 77.13 195.83 74.28 197.47 L 18.58 229.62 Z M 131 196 L 131 104 L 85 79 L 85 173 Z M 69.103 173.19 L 69 81 L 41.443 96.861 L 40.84 189.29 Z M 197.95 128.27 C 198.61 127.71 205.11 116.6 206.32 114.7 L 214.67 100.87 C 219.37 92.79 227.67 80.49 230.71 72.58 C 232.95 66.77 234.56 61.16 233.57 54.1 C 232.71 47.94 230.25 42.31 227.31 38.24 C 212.24 17.47 182.5 18.64 168.7 38.13 C 161.38 48.43 160.06 59.6 165.14 72.64 C 167.2 77.95 169.97 82.29 172.82 86.92 C 175.71 91.62 178.36 96.06 181.17 100.74 L 195.79 124.88 C 196.36 125.84 197.33 127.63 197.95 128.27 Z M 196.09 47.77 C 203 48 208 52 209.03 57.39 C 209 63 205 69 199.49 70.3 C 193 70 188 68 186.52 60.85 C 187 54 189 50 196.09 47.77 Z" />
            </svg>
          </div>
        </Button>
        <Button className="buttonS textButtom" style={{ paddingLeft: '1.1rem', backgroundColor: this.iconsColors[item.jl_pl > 0 ? 4 : 2] }} onClick={event => { this.handleClickAdd(event, 'anchorElItem', item, item.list_plan, 'estimativa/new', 'estimativa/edit') }}
          title={this.props.res.PLANEJAMENTO}>
          <MaterialIcon icon="flight_takeoff" className="iconS icon-pos iconMenu" />
        </Button>
        <Button className="buttonS textButtom" disabled={item.type === this.filters.type[3].value || item.type === this.filters.type[4].value || item.status === 'close' || item.jl_pl === 0} style={{
          paddingLeft: '1.1rem', backgroundColor: this.iconsColors[(item.type === this.filters.type[3].value || item.type === this.filters.type[4].value) ? 1 : item.status === 'open' && item.jl_pl > 0 ? 3 : item.status === 'private' && item.jl_pl > 0 ? 2 : 1]
        }} onClick={event => { this.setState({ menuItem: item }, (event) => { item.status === 'open' ? this.updateStatusTrabalho(item.id, 'private') : this.updateStatusTrabalho(item.id, 'open'); }) }}
          title={item.status === 'open' && item.jl_pl > 0 ? this.props.res.REMOVER_LISTA_DGPS : item.status !== 'close' &&
            item.jl_pl > 0 ? this.props.res.ADICIONAR_LISTA_DGPS : undefined}>
          {item.status === 'open' && item.jl_pl > 0 ?
            <MaterialIcon icon="network_wifi_2_bar" className="iconS icon-pos iconMenu" />
            :
            <MaterialIcon icon="signal_wifi_bad" className="iconS icon-pos iconMenu" />
          }
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button
          className="buttonS textButtom"
          style={{
            paddingLeft: '1.1rem',
            backgroundColor: this.iconsColors[item.list_rel.length > 0 && item.list_rel[0].progress_task === 100 ? 3 : item.list_rel.length > 0 ? 2 : 1],
            position: 'relative',
          }}
          disabled={item.list_rel.length === 0}
          onClick={event => { this.handleClickAdd(event, 'anchorElItem', item, item.list_rel, null, 'relatorio') }}
          /*onClick={event => this.props.link(`/app/relatorio/${item.guid}`)}*/
          title={this.props.res.RELATORIO}
        >
          <div style={{ marginTop: '.5rem' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="2rem"
              height="2rem"
              fill="currentColor"
              className="bi bi-file-earmark-arrow-down-fill"
              viewBox="-4 -8 32 32"
            >
              <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
              <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
            </svg>
          </div>

          {/* Alerta com o ícone de clima */}
          {Array.isArray(item.list_climate) && item.list_climate.length > 0 && (
            <span
              style={{
                position: 'absolute',
                top: '-7px',
                left: '24px',
                width: '1.25rem',
                height: '1.25rem',
                backgroundColor: '#F16623',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid white',
              }}
            >
              <CloudQueueIcon style={{ fontSize: '0.85rem', color: 'white' }} />
            </span>
          )}
        </Button>
        <Button className="buttonS textButtom" style={{ paddingLeft: '1.1rem', backgroundColor: this.iconsColors[item.jl_ap > 0 ? 3 : item.jl_sk > 0 ? 2 : 1] }} disabled={item.jl_ap === 0 && item.jl_sk === 0} onClick={event => { this.handleClickAdd(event, 'anchorElItem', item, item.list_check, 'avaliacao', 'avaliacao') }}
          title={this.props.res.ANALISE_FINANCEIRA}>
          <div style={{ marginTop: '.5rem' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="0 -100 800 800">
              <path d="m356.21 36.715h-0.023438c-32.711 0-64.109 5.6211-93.293 15.93l20.793 100.73c17.465-4.8477 35.82-7.3867 54.75-7.3867l0.75391 0.011719c9.9297-0.011719 19.699 0.73047 29.266 2.1406l36.332-107.25c-15.738-2.7617-31.93-4.1758-48.453-4.1758zm-112.84 23.672h-0.003906c-36.398 16.031-68.742 39.578-95.07 68.676l50.934 71.121c18.836-17.145 40.672-30.855 64.582-40.203zm145.56 91.859h0.003906c27.145 6.8711 52.227 19.188 74.094 35.762l0.003906 0.003907c6.0586 4.5938 11.875 9.5156 17.414 14.738l104.43-48.102c-4.0703-5.7812-8.3867-11.383-12.902-16.812l-0.007813-0.003907c-37.34-44.875-88.414-77.879-146.76-92.609zm-254.34-6.793-0.003906 0.003906c-20.887 26.906-36.977 57.75-46.984 91.219l59.719 35.336c9.3906-21.02 21.957-40.211 37.059-56.93zm221.34 153.61h0.003906c9.6445 0 17.461 7.8164 17.461 17.461 0 9.6484-7.8203 17.48-17.469 17.48h-0.007813c-9.6484-0.007812-17.469-7.8281-17.469-17.477s7.8203-17.465 17.469-17.465zm-273.69-41.48-0.003907 0.011718c-4.1602 19.145-6.3516 39.094-6.3516 59.551 0 7.2031 0.27344 14.344 0.80469 21.41l52.059 7.8086c1.3516-19.066 5.0977-37.438 10.934-54.797zm531.25-101.49h-0.015625c-1.7812 0-3.4062 0.60156-5.1914 1.4219l-235.39 108.42c-5.332-1.7852-11.035-2.7539-16.969-2.7539h-0.050781c-29.441-0.007812-53.285 23.902-53.285 53.34 0 29.457 23.875 53.328 53.328 53.348h0.011719c25.906-0.015625 47.477-18.48 52.305-42.965 0-0.003906 0.007813-0.007812 0.007813-0.007812 1.8945-1.3633 210.42-151.41 210.42-151.41 4.3008-3.0977 6.6055-8.4414 4.332-13.375-1.2266-2.6641-3.4453-4.5586-6.0156-5.4492l-0.03125-0.007812c-1.0977-0.39062-2.2617-0.55859-3.4219-0.55859zm-534.38 203.81v0.007813c3.2773 21.371 8.9805 42.023 16.828 61.586l37.875-9.0391c-3.3359-14.598-5.25-29.688-5.582-45.191zm25.391 80.816s0.003907 0.007813 0.003907 0.007813c7.5625 15.375 16.496 29.965 26.641 43.605l21.938-19.594c-5.3672-10.371-9.9492-21.156-13.668-32.359zm39.613 59.789v0.007813c5.6875 6.5625 11.641 12.871 17.906 18.891l0.003906 0.007813c2.125 2.3086 5.1758 3.7695 8.5664 3.7695h0.003906c6.418-0.007812 11.621-5.2109 11.621-11.629v-0.007812c0-2.8281-1.0117-5.418-2.6875-7.4297l-0.097656-0.11328c-5.6133-6.7305-10.852-13.73-15.648-21.078z" />
            </svg>
          </div>
        </Button>
        <Button className="buttonS textButtom" style={{ paddingLeft: '1.1rem', backgroundColor: this.iconsColors[itensQualidade ? 3 : item.jl_sk > 0 ? 2 : 1] }} disabled={item.jl_an === 0 && item.jl_sk === 0} onClick={event => { this.handleClickAdd(event, 'anchorElItem', item, item.list_analise, 'qualidade', 'qualidade') }}
          title={this.props.res.ANALISE_QUALIDADE}>
          <div style={{ marginTop: '.5rem' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="-20 -50 400 400">
              <g id="_2539151417168">
                <path className="fil0" d="M133 17.44c58.05,0 106.23,43.9 115.57,101.56l-27.61 0c-8.97,-41.97 -44.93,-73.35 -87.96,-73.35 -49.77,0 -90.11,41.99 -90.11,93.79 0,25.33 9.64,48.3 25.32,65.18l-19.24 19.88c-20.54,-21.98 -33.19,-51.98 -33.19,-85.06 0,-67.38 52.48,-122 117.22,-122z" />
                <path className="fil0" d="M57.61 154.63l-42.68 0c-1.63,0 -2.97,-1.33 -2.97,-2.96l0 -24.46c0,-1.63 1.34,-2.96 2.97,-2.96l42.68 0c1.64,0 2.97,1.33 2.97,2.96l0 24.46c0,1.63 -1.33,2.96 -2.97,2.96z" />
                <path className="fil0" d="M67.46 95.53l-32.35 -26.76c-1.42,-1.16 -1.62,-3.26 -0.45,-4.67l15.13 -18.3c1.17,-1.41 3.27,-1.61 4.68,-0.45l32.35 26.76c1.41,1.16 1.61,3.26 0.45,4.67l-15.13 18.3c-1.17,1.41 -3.28,1.61 -4.68,0.45z" />
                <path className="fil0" d="M146.59 16.83l0 41.44c0,1.98 -1.62,3.59 -3.59,3.59l-23.21 0c-1.98,0 -3.59,-1.61 -3.59,-3.59l0 -41.44c0,-1.98 1.61,-3.59 3.59,-3.59l23.21 0c1.97,0 3.59,1.61 3.59,3.59z" />
                <g>
                  <path className="fil0" d="M119.46 126.91l46.07 -48.13c5.44,-5.69 14.54,-5.89 20.22,-0.44l0.01 0c5.69,5.45 5.88,14.54 0.44,20.23l-46.08 48.13c-5.44,5.69 -14.53,5.88 -20.22,0.44l-0.01 0c-5.68,-5.45 -5.88,-14.54 -0.43,-20.23z" />
                  <path className="fil0" d="M130.02 114.41c12.39,0 22.42,10.03 22.42,22.42 0,12.39 -10.03,22.43 -22.42,22.43 -12.39,0 -22.42,-10.04 -22.42,-22.43 0,-12.39 10.03,-22.42 22.42,-22.42z" />
                </g>
                <path className="fil0" d="M219.66 183.43l-19.48 -17.87 -42.87 42.86c-5.16,4.94 -9.72,4.52 -13.8,0l-25.63 -25.63c-6.35,-6.83 -12.86,-7.46 -19.58,0l-53.12 53.12c-5.03,8.19 12.45,23.9 20.39,15.83l35.82 -35.81c4.6,-4.75 9.19,-4.55 13.81,0l26.08 26.08c6.42,6.89 13.02,6.35 19.79,0l58.59 -58.58zm-8.47 -28.53l-21.82 -22.91 61.56 -0.4 0 62.24 -19.33 -21.41 -11.94 11.01 -19.48 -17.87 11.01 -10.66z" />
              </g>
            </svg>
          </div>

          {hasClimateData && (
            <span
              style={{
                position: 'absolute',
                top: '-7px',
                left: '24px',
                width: '1.25rem',
                height: '1.25rem',
                backgroundColor: '#F16623',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid white',
              }}
            >
              <CloudQueueIcon style={{ fontSize: '0.85rem', color: 'white' }} />
            </span>
          )}
        </Button>
        <Button className="buttonS textButtom" disabled={true} style={{ paddingLeft: '1.1rem', backgroundColor: this.iconsColors[1] }}
          title={this.props.res.RELATORIO__MAPA}>
          <MaterialIcon icon="cloud" className="iconS icon-pos iconMenu" />
        </Button>
      </div>
    </div >;
  };

  changePlanes = (id) => {
    if (id) {
      let sel = this.state.selectedPlanes;
      if (sel.indexOf(id) >= 0) {
        this.setNewJobs('selectedPlanes', sel.filter(item => item !== id));
      } else {
        this.setNewJobs('selectedPlanes', [id, ...this.state.selectedPlanes]);
      }
    } else {
      this.setNewJobs('selectedPlanes', []);
    }
  };

  CompPlane = (key, item) => {
    const isON = item.online ? this.iconsColors[3] : this.iconsColors[1];
    const values = {
      qtd_total: !item ? 0 : item.qtd_exe,
      qtd_sended: !item ? 0 : item.qtd_sended ? item.qtd_sended : 0,
      qtd_received: !item ? 0 : item.qtd_received ? item.qtd_received : 0
    };
    return <div key={key} className='divContent' onClick={event => { this.changePlanes(item.id) }}
      style={{
        cursor: 'pointer', position: 'relative', display: 'flex', justifyContent: 'center', flexWrap: 'wrap',
        padding: '2rem', borderRadius: '.8rem', minWidth: '8rem', width: '8rem', height: '13.5rem', backgroundColor:
          this.state.selectedPlanes.length > 0 && this.state.selectedPlanes.includes(item.id) ? '#343a40' : '#f5f5f5', color:
          this.state.selectedPlanes.length > 0 && this.state.selectedPlanes.includes(item.id) ? '#f5f5f5' : '#343a40'
      }}>
      <SvgIcon viewBox="0 0 800 800" className="iconArrow" style={{
        color:
          this.state.selectedPlanes.length > 0 && this.state.selectedPlanes.includes(item.id) ? '#f5f5f5' : '#343a40', width: '1.5rem', height: '1.5rem'
      }}>
        <path d="M 0 156.81 L 0 0 L 65.28 0 L 125.41 103.72 L 243.59 87.54 C 260.71 67.18 282.02 49.29 307.72 33.88 C 333.41 18.46 354.72 10.66 371.85 10.66  L 381.93 10.66 C 395.25 10.28 409.14 19.04 423.8 36.54 C 438.26 54.24 448.73 67.56 455.58 76.51 L 734.36 95.92 L 734.36 21.32 L 753.2 21.32 L 753.2  116.66 C 757.39 116.66 762.34 117.61 768.62 119.7 C 774.71 121.8 777.75 123.89 777.75 126.17 C 777.75 128.65 774.71 132.07 768.62 136.45 C 762.34  140.64 757.58 142.73 753.77 142.73 L 753.77 242.06 L 734.74 242.06 L 734.74 168.99 L 569.18 208 L 569.18 251.01 C 583.46 256.15 590.5 266.23 590.5  281.08 C 590.5 302.58 579.84 313.43 558.72 313.43 C 537.02 313.43 526.37 302.58 526.37 281.08 C 526.37 265.47 533.98 255.19 549.2 250.44 L 549.2 210.29  L 501.82 225.89 L 384.78 225.89 L 0 156.81 Z M 23.98 430.46 C 23.98 416.38 30.83 409.34 44.53 409.34 C 58.81 409.34 65.85 416.38 65.85 430.46 C 65.85  444.16 58.81 451.2 44.53 451.2 C 30.83 451.2 23.98 444.16 23.98 430.46 Z M 26.83 579.27 C 26.83 565.19 33.88 558.15 47.96 558.15 C 61.66 558.15 68.51  565.19 68.51 579.27 C 68.51 593.16 61.66 600.01 47.96 600.01 C 33.88 600.01 26.83 593.16 26.83 579.27 Z M 65.85 652.92 C 65.85 639.22 72.89 632.37  86.97 632.37 C 100.67 632.37 107.71 639.22 107.71 652.92 C 107.71 667 100.67 674.04 86.97 674.04 C 72.89 674.04 65.85 667 65.85 652.92 Z M 66.42 504.11  C 66.42 490.02 73.46 482.98 87.54 482.98 C 101.24 482.98 108.09 490.02 108.09 504.11 C 108.09 517.81 101.24 524.66 87.54 524.66 C 73.46 524.66 66.42  517.81 66.42 504.11 Z M 106.57 430.46 C 106.57 416.38 113.61 409.34 127.69 409.34 C 141.39 409.34 148.24 416.38 148.24 430.46 C 148.24 444.16 141.39  451.2 127.69 451.2 C 113.61 451.2 106.57 444.16 106.57 430.46 Z M 109.23 579.27 C 109.23 565.19 116.28 558.15 130.55 558.15 C 144.25 558.15 151.1  565.19 151.1 579.27 C 151.1 593.16 144.25 600.01 130.55 600.01 C 116.28 600.01 109.23 593.16 109.23 579.27 Z M 148.24 652.92 C 148.24 639.22 155.29  632.37 169.56 632.37 C 183.26 632.37 190.11 639.22 190.11 652.92 C 190.11 667 183.26 674.04 169.56 674.04 C 155.29 674.04 148.24 667 148.24 652.92  Z M 149.39 504.11 C 149.39 490.02 156.24 482.98 170.13 482.98 C 183.83 482.98 190.68 490.02 190.68 504.11 C 190.68 517.81 183.83 524.66 170.13 524.66  C 156.24 524.66 149.39 517.81 149.39 504.11 Z M 151.1 355.86 C 151.1 341.97 157.95 335.12 171.65 335.12 C 185.92 335.12 192.97 341.97 192.97 355.86  C 192.97 369.95 185.92 376.99 171.65 376.99 C 157.95 376.99 151.1 369.95 151.1 355.86 Z M 188.97 430.46 C 188.97 416.38 196.01 409.34 210.28 409.34  C 223.98 409.34 230.83 416.38 230.83 430.46 C 230.83 444.16 223.98 451.2 210.28 451.2 C 196.01 451.2 188.97 444.16 188.97 430.46 Z M 192.39 579.27  C 192.39 565.19 199.25 558.15 212.95 558.15 C 226.65 558.15 233.69 565.19 233.69 579.27 C 233.69 593.16 226.65 600.01 212.95 600.01 C 199.25 600.01  192.39 593.16 192.39 579.27 Z M 231.41 652.92 C 231.41 639.22 238.26 632.37 251.96 632.37 C 266.23 632.37 273.27 639.22 273.27 652.92 C 273.27 667 266.23  674.04 251.96 674.04 C 238.26 674.04 231.41 667 231.41 652.92 Z M 231.98 504.11 C 231.98 490.02 238.83 482.98 252.53 482.98 C 266.61 482.98 273.84 490.02  273.84 504.11 C 273.84 517.81 266.61 524.66 252.53 524.66 C 238.83 524.66 231.98 517.81 231.98 504.11 Z M 233.69 355.86 C 233.69 341.97 240.54 335.12  254.24 335.12 C 268.32 335.12 275.36 341.97 275.36 355.86 C 275.36 369.95 268.32 376.99 254.24 376.99 C 240.54 376.99 233.69 369.95 233.69 355.86 Z M  272.13 430.46 C 272.13 416.38 278.98 409.34 292.68 409.34 C 306.76 409.34 313.81 416.38 313.81 430.46 C 313.81 444.16 306.76 451.2 292.68 451.2 C 278.98  451.2 272.13 444.16 272.13 430.46 Z M 274.79 579.27 C 274.79 565.19 281.83 558.15 295.54 558.15 C 309.62 558.15 316.66 565.19 316.66 579.27 C 316.66 593.16  309.62 600.01 295.54 600.01 C 281.83 600.01 274.79 593.16 274.79 579.27 Z M 277.08 284.5 C 277.08 270.23 283.93 263.19 297.82 263.19 C 311.9 263.19 318.94  270.23 318.94 284.5 C 318.94 298.2 311.9 305.05 297.82 305.05 C 283.93 305.05 277.08 298.2 277.08 284.5 Z M 313.81 652.92 C 313.81 639.22 321.04 632.37  335.12 632.37 C 348.82 632.37 355.67 639.22 355.67 652.92 C 355.67 667 348.82 674.04 335.12 674.04 C 321.04 674.04 313.81 667 313.81 652.92 Z M 314.38  504.11 C 314.38 490.02 321.61 482.98 335.69 482.98 C 349.39 482.98 356.24 490.02 356.24 504.11 C 356.24 517.81 349.39 524.66 335.69 524.66 C 321.61 524.66  314.38 517.81 314.38 504.11 Z M 316.09 355.86 C 316.09 341.97 323.13 335.12 337.4 335.12 C 351.1 335.12 357.95 341.97 357.95 355.86 C 357.95 369.95 351.1  376.99 337.4 376.99 C 323.13 376.99 316.09 369.95 316.09 355.86 Z M 345.58 76.51 L 418.66 76.51 L 382.5 39.21 L 345.58 39.21 L 345.58 76.51 Z M 354.53  430.46 C 354.53 416.38 361.38 409.34 375.27 409.34 C 389.35 409.34 396.39 416.38 396.39 430.46 C 396.39 444.16 389.35 451.2 375.27 451.2 C 361.38 451.2  354.53 444.16 354.53 430.46 Z M 357.38 579.27 C 357.38 565.19 364.42 558.15 378.51 558.15 C 392.4 558.15 399.25 565.19 399.25 579.27 C 399.25 593.16 392.4  600.01 378.51 600.01 C 364.42 600.01 357.38 593.16 357.38 579.27 Z M 359.67 284.5 C 359.67 270.23 366.71 263.19 380.79 263.19 C 394.49 263.19 401.34 270.23  401.34 284.5 C 401.34 298.2 394.49 305.05 380.79 305.05 C 366.71 305.05 359.67 298.2 359.67 284.5 Z M 369.18 143.87 C 387.26 149.58 405.53 152.82 423.99  153.96 C 442.44 155.1 461.1 155.67 480.12 155.67 C 498.58 155.29 516.85 154.34 534.74 152.82 C 552.44 151.29 570.13 147.3 587.64 140.64 C 568.99 134.93  550.73 131.31 532.65 129.79 C 514.76 128.08 496.87 126.74 479.55 126.17 C 432.36 128.65 395.44 134.55 369.18 143.87 Z M 396.96 504.11 C 396.96 490.02 404.01  482.98 418.09 482.98 C 431.98 482.98 438.83 490.02 438.83 504.11 C 438.83 517.81 431.98 524.66 418.09 524.66 C 404.01 524.66 396.96 517.81 396.96 504.11 Z  M 398.68 355.86 C 398.68 341.97 405.72 335.12 419.8 335.12 C 433.5 335.12 440.54 341.97 440.54 355.86 C 440.54 369.95 433.5 376.99 419.8 376.99 C 405.72  376.99 398.68 369.95 398.68 355.86 Z M 437.12 430.46 C 437.12 416.38 444.16 409.34 458.24 409.34 C 472.13 409.34 478.98 416.38 478.98 430.46 C 478.98 444.16  472.13 451.2 458.24 451.2 C 444.16 451.2 437.12 444.16 437.12 430.46 Z M 442.06 284.5 C 442.06 270.23 449.11 263.19 463.38 263.19 C 477.08 263.19 483.93  270.23 483.93 284.5 C 483.93 298.2 477.08 305.05 463.38 305.05 C 449.11 305.05 442.06 298.2 442.06 284.5 Z" />
      </SvgIcon>
      {item ? <div style={{
        borderRadius: '2px', height: '4px', width: '50px', position: 'absolute', backgroundColor: isON, top: '1.3rem', left: '2.4rem'
      }}></div> : null}
      <div style={{ textAlign: 'center' }}>
        {item.name.length > 13 ? item.name.substring(0, 13) + '...' : item.name}
        <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center' }}>
          <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{values.qtd_total}</h2>
          <MaterialIcon icon="autorenew" style={{ marginTop: '.3rem', height: '1.5rem' }} />
        </div>
        <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center' }}>
          <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{values.qtd_sended}</h2>
          <MaterialIcon icon="wysiwyg" style={{ marginTop: '.3rem' }} />
        </div>
        <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center' }}>
          <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{values.qtd_received}</h2>
          <MaterialIcon icon="emoji_flags" style={{ marginTop: '.3rem' }} />
        </div>
      </div>
    </div>
  };
  stringToDate = (date) => {
    let d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d;
  };

  dateToString = (date) => {
    if (!date) date = new Date();
    let ret = date.getFullYear() + '-';
    ret += (date.getMonth() + 1).toString().padStart(2, '0') + '-';
    ret += date.getDate().toString().padStart(2, '0');
    return ret;
  };

  onCloseEditMap = () => {
    if (this.state.typeWindow === 'edit') {
      this.setState({ typeWindow: 'view' });
    } else {
      this.setState({ showForm: false });
    }
  };

  changeView = () => {
    this.setState({ typeWindow: this.state.typeWindow === 'edit' ? 'view' : 'edit' });
  };

  openPoly = (id) => {
    this.setState({ showForm: true, idPopUp: id });
  };


  getOnlineFarmDayRange = () => {
    const baseDate = new Date();
    baseDate.setHours(0, 0, 0, 0);

    const endDate = new Date(baseDate.getTime());
    endDate.setDate(endDate.getDate() + 1);

    return {
      dateIni: baseDate.getTime(),
      dateEnd: endDate.getTime(),
      dateIniDate: baseDate,
      dateEndDate: endDate
    };
  };

  getOnlineFarmRunningJobs = () => {
    const jobs = Array.isArray(this.state.jobList) ? this.state.jobList : [];
    const dayRange = this.getOnlineFarmDayRange();
    const dateIni = dayRange.dateIni;
    const dateEnd = dayRange.dateEnd;

    return jobs.filter((job) => this.isOnlineFarmJobInPeriod(job, dateIni, dateEnd));
  };

  isOnlineFarmJobInPeriod = (job, dateIni, dateEnd) => {
    if (!job || job.status === 'canceled' || job.status === 'deleted') return false;

    const dates = this.getOnlineFarmJobDates(job);
    if (!dates.length) return true;

    for (let i = 0; i < dates.length; i++) {
      if (dates[i] >= dateIni && dates[i] < dateEnd) return true;
    }

    return false;
  };

  getOnlineFarmJobDates = (job) => {
    const dates = [];
    const addDate = (value) => {
      const numberValue = Number(value || 0);
      if (numberValue > 0) {
        dates.push(numberValue);
        return;
      }

      const parsed = value ? new Date(value).getTime() : 0;
      if (parsed > 0) dates.push(parsed);
    };

    const addItemDates = (item) => {
      if (!item) return;
      addDate(item.startDate);
      addDate(item.endDate);
      addDate(item.date);
      addDate(item.datetime);
      addDate(item.created);
      addDate(item.updated);
    };

    addItemDates(job);

    const lists = ['list_exe', 'list_plan', 'list_analise'];
    for (let i = 0; i < lists.length; i++) {
      const arr = Array.isArray(job[lists[i]]) ? job[lists[i]] : [];
      for (let j = 0; j < arr.length; j++) addItemDates(arr[j]);
    }

    return dates;
  };

  hasOnlineFarmMapAccess = () => {
    if (this.getOnlineFarmRunningJobs().length > 0) return true;

    const planeValues = this.state.planeValues || {};
    return Number(this.state.onlinePlanes || 0) > 0 ||
      Number(this.state.onlineSources || 0) > 0 ||
      Number(planeValues.qtd_total || 0) > 0 ||
      Number(planeValues.qtd_sended || 0) > 0 ||
      Number(planeValues.qtd_received || 0) > 0;
  };

  openOnlineFarmMap3D = () => {
    if (!this.hasOnlineFarmMapAccess()) return;

    const onlineFarmMapJobs = this.getOnlineFarmRunningJobs();
    const dayRange = this.getOnlineFarmDayRange();

    this.setState({
      showOnlineFarmMap3D: true,
      onlineFarmMapJobs: onlineFarmMapJobs,
      onlineFarmMapPlanes: this.state.planes || [],
      onlineFarmMapPlaneCatalog: this.state.editPlanes || [],
      onlineFarmMapDateIni: dayRange.dateIniDate,
      onlineFarmMapDateEnd: dayRange.dateEndDate
    });
  };

  closeOnlineFarmMap3D = () => {
    this.setState({
      showOnlineFarmMap3D: false,
      onlineFarmMapJobs: [],
      onlineFarmMapPlanes: [],
      onlineFarmMapPlaneCatalog: [],
      onlineFarmMapDateIni: null,
      onlineFarmMapDateEnd: null
    });
  };

  //upload de arquivos zjob to the job
  guidUpload = '';
  loadFileList = name => file => {
    let filePath = file.target.files[0];
    let ext = fileName => fileName.split(".").pop();

    if (ext(filePath.name.toLowerCase()) === 'zjob') {
      this.uploadFile(filePath);
    }
    document.getElementById(name).value = null;
  };

  //upload de arquivos zjob
  loadFile = file => {
    this.guidUpload = '';
    let filePath = file.target.files[0];
    let ext = fileName => fileName.split(".").pop();

    if (ext(filePath.name.toLowerCase()) === 'zjob') {
      this.uploadFile(filePath);
    }
    document.getElementById('contained-button-file').value = null;
  };

  uploadFile = (file) => {
    this.setState({ progress: true });

    let apiUrl = Config.server + '/dgps/job';
    //let apiUrl = Config.server + '/fix_job_file';
    let method = 'POST';

    const formData = new FormData();

    formData.append('file', file);
    if (this.guidUpload) {
      formData.append('guid', this.guidUpload);
    }

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((resData) => {
        if (resData.status !== 200) throw resData;
        else return resData.json();
        //else return resData.blob();
      })
      .then(
        (result) => {
          /*  let file_name = 'fixed.zjob';
            saveAs(result, file_name);*/

          this.setState({ progress: false });
          this.updateList(1, true);
          this.updateListPlanes();
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  async handleScroll() {
    const scroller = this.scrollerRef.current;
    if (scroller.scrollHeight - scroller.scrollTop < scroller.clientHeight + 5) {
      if (!this.pageEnd) {
        let pageNum = this.state.pageNum + 1;
        this.setState({ pageNum: pageNum });
        this.updateList(pageNum);
      }
    }
  };

  handleClickAdd = (event, anchorEl, item, list, newUrl, viewUrl) => {
    let url = this.state.url;
    url.newUrl = newUrl;
    url.viewUrl = viewUrl;
    this.setState({
      url,
      [anchorEl]: event.currentTarget,
      menuItem: item,
      menuItemList: list ? list : [],
    });
  };
  handleCloseAdd = (anchorEl) => {
    this.setState({ [anchorEl]: null, menuItemList: [] });
  };

  handleClickList = (event, item, list, action) => {
    this.setState({
      anchorEl: event.currentTarget,
      menuItem: item,
      menuItemList: list ? list : [],
      action
    });
  };

  handleClick = (event, item) => {
    this.setState({ anchorEl: event.currentTarget, menuItem: item, menuItemList: [] });
  };
  handleClose = () => {
    this.setState({ anchorEl: null }, () => {
      setTimeout(() => {
        this.setState({ openListPlanes: false, selectedSendPlanes: [] });
      }, 300);
    });
  };

  mergeItem = () => {
    this.handleClose();
    if (!this.state.menuItem || !this.state.menuItem.id || !this.state.selected || !this.state.selected.id) {
      return;
    }
    this.setState({ progress: true });
    let apiUrl = Config.server + `/job_merge/${this.state.menuItem.id}/${this.state.selected.id}`;
    let method = 'GET';

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((resData) => {
        if (resData.status !== 200) throw resData;
        else return resData.json();
      })
      .then(
        (result) => {
          this.setState({ progress: false, selected: null });
          notification.open({
            message: this.props.res.SUCESSO,
            description: 'Junção bem sucedida',
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
          this.updateList(1, true);
          this.updateListPlanes();
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };
  sendFile = () => {
    const selectedSendPlanes = this.state.selectedSendPlanes.slice();
    const selectedSendClients = this.state.selectedSendClients.slice();

    this.handleClose();
    if (this.compartilhar) {
      this.sendFileClient(selectedSendClients);
    } else if (this.state.bulkSendMode) {
      this.sendBulkFilePlane(selectedSendPlanes);
    } else {
      this.sendFilePlane(selectedSendPlanes);
    }
  }
  sendFilePlane = (list_plane) => {
    this.setState({ progress: true });
    let apiUrl = Config.server + '/transfer';
    let method = 'POST';

    if (!this.state.menuItemListItem) {
      notification.open({
        message: this.props.res.ERRO,
        description: 'Link não encontrado',
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    const formData = new URLSearchParams();
    formData.append('list_plane', JSON.stringify(list_plane));
    formData.append('guid', this.state.menuItemListItem.guid);
    formData.append('type', 'job');

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((resData) => {
        if (resData.status !== 200) throw resData;
        else return resData.json();
      })
      .then(
        (result) => {
          this.setState({ progress: false });
          if (result.msg) {
            notification.open({
              message: this.props.res.ENVIANDO_TRABALHO,
              icon: <MaterialIcon icon="check_circle" className="text-success" />
            });
            //this.updateList(1, false, this.state.menuItem.id);
            setTimeout(() => {
              this.updateList(1, true);
            }, 200);
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };


  sendBulkFilePlane = async (list_plane) => {
    const selectedBulkPlans = Array.isArray(this.state.selectedBulkPlans) ? this.state.selectedBulkPlans.slice() : [];

    if (!selectedBulkPlans.length) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.NENHUM_PLANEJAMENTO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    if (!list_plane || !list_plane.length) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.NENHUM_AERONAVE,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    this.setState({ progress: true });

    let success = 0;
    let fail = 0;

    for (let i = 0; i < selectedBulkPlans.length; i++) {
      const plan = selectedBulkPlans[i];

      if (!plan || !plan.guid) {
        fail++;
        continue;
      }

      try {
        const formData = new URLSearchParams();
        formData.append('list_plane', JSON.stringify(list_plane));
        formData.append('guid', plan.guid);
        formData.append('type', 'job');

        const resData = await fetch(Config.server + '/transfer', {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': localStorage.getItem('access-token-jwt')
          }
        });

        if (resData.status !== 200) throw resData;

        const result = await resData.json();
        if (result && result.msg) {
          success++;
        } else {
          fail++;
        }
      } catch (error) {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
          return;
        }
        fail++;
      }
    }

    this.setState({
      progress: false,
      bulkSendMode: false,
      selectedBulkPlans: [],
      selectedSendPlanes: [],
      openListPlanes: false,
    });

    if (success > 0 && fail === 0) {
      notification.open({
        message: this.props.res.ENVIANDO_TRABALHO,
        icon: <MaterialIcon icon="check_circle" className="text-success" />
      });
    } else if (success > 0 && fail > 0) {
      notification.open({
        message: this.props.res.ERRO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    } else {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }

    this.updateList(1, true);
    this.updateListPlanes();
  };

  sendFileClient = (list_client) => {
    this.setState({ progress: true });
    let apiUrl = Config.server + '/compartilhar';
    let method = 'POST';

    if (!this.state.menuItemListItem) {
      notification.open({
        message: this.props.res.ERRO,
        description: 'Link não encontrado',
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    const formData = new URLSearchParams();
    formData.append('list_client', JSON.stringify(list_client));
    formData.append('guid', this.state.menuItemListItem.guid);
    formData.append('type', 'job');

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((resData) => {
        if (resData.status !== 200) throw resData;
        else return resData.json();
      })
      .then(
        (result) => {
          this.setState({ progress: false });
          if (result.msg) {
            notification.open({
              message: this.props.res.COMPARTILHANDO_TRABALHO,
              icon: <MaterialIcon icon="check_circle" className="text-success" />
            });
            /*setInterval(() => {
              this.updateList(1, true);
            }, 200);*/
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  listSendPlanes = (item, listItem) => {
    let planes = this.state.planes.filter(plane => (item.id_plane_pl === plane.id));
    let selPlanes = [];
    if (planes.length > 0) {
      selPlanes.push(planes[0].id);
    }
    this.setState({ selectedSendPlanes: selPlanes, menuItemList: [], openListPlanes: true, menuItemListItem: listItem });
  };

  getBulkPlansFromJob = (item) => {
    if (!item || !item.list_plan || item.list_plan.length === 0) {
      return [];
    }

    return item.list_plan.filter(plan => plan && plan.guid);
  };

  getSelectedBulkPlansFromJob = (item) => {
    const bulkPlans = this.getBulkPlansFromJob(item);

    if (!bulkPlans.length) {
      return [];
    }

    return bulkPlans.filter(plan => this.isBulkPlanSelected(plan.guid));
  };

  isBulkPlanSelected = (guid) => {
    return this.state.selectedBulkPlans.filter(item => item.guid === guid).length > 0;
  };

  closeBulkPlanSelector = () => {
    this.setState({ bulkPlanAnchorEl: null, bulkPlanJob: null });
  };

  toggleBulkSendMode = () => {
    this.compartilhar = false;
    this.setState({
      bulkSendMode: !this.state.bulkSendMode,
      selectedBulkPlans: [],
      selectedSendPlanes: [],
      openListPlanes: false,
      menuItemList: [],
      menuItemListItem: null,
      anchorEl: null,
      bulkPlanAnchorEl: null,
      bulkPlanJob: null,
    });
  };

  cancelBulkSendMode = () => {
    this.compartilhar = false;
    this.setState({
      bulkSendMode: false,
      selectedBulkPlans: [],
      selectedSendPlanes: [],
      openListPlanes: false,
      menuItemList: [],
      menuItemListItem: null,
      anchorEl: null,
      bulkPlanAnchorEl: null,
      bulkPlanJob: null,
    });
  };

  handleBulkSendButton = (event) => {
    if (!this.state.bulkSendMode) {
      this.toggleBulkSendMode();
      return;
    }

    if (!this.state.selectedBulkPlans || this.state.selectedBulkPlans.length === 0) {
      this.cancelBulkSendMode();
      return;
    }

    this.openBulkSendPlanes(event);
  };

  handleBulkCardSelection = (event, item) => {
    if (event) {
      if (event.preventDefault) event.preventDefault();
      if (event.stopPropagation) event.stopPropagation();
    }

    const bulkPlans = this.getBulkPlansFromJob(item);

    if (!bulkPlans.length) {
      notification.open({
        message: this.props.res.ERRO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    const selectedBulkPlansFromJob = this.getSelectedBulkPlansFromJob(item);

    if (selectedBulkPlansFromJob.length > 0) {
      this.clearBulkPlansFromJob(item);
      return;
    }

    if (bulkPlans.length === 1) {
      this.toggleBulkPlan(item, bulkPlans[0]);
      return;
    }

    this.setState({
      bulkPlanAnchorEl: event ? event.currentTarget : null,
      bulkPlanJob: item,
    });
  };

  clearBulkPlansFromJob = (item) => {
    const bulkPlans = this.getBulkPlansFromJob(item);
    const guids = bulkPlans.map(plan => plan.guid);
    const selectedBulkPlans = this.state.selectedBulkPlans.filter(plan => guids.indexOf(plan.guid) === -1);

    this.setState({
      selectedBulkPlans,
      bulkPlanAnchorEl: null,
      bulkPlanJob: null,
    });
  };

  toggleBulkPlan = (item, plan) => {
    const planItem = plan || (this.getBulkPlansFromJob(item).length > 0 ? this.getBulkPlansFromJob(item)[0] : null);

    if (!planItem || !planItem.guid) {
      notification.open({
        message: this.props.res.ERRO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    let selectedBulkPlans = this.state.selectedBulkPlans.slice();
    const index = selectedBulkPlans.findIndex(selected => selected.guid === planItem.guid);

    if (index > -1) {
      selectedBulkPlans.splice(index, 1);
    } else {
      selectedBulkPlans.push({
        guid: planItem.guid,
        id: planItem.id,
        title: planItem.title ? planItem.title : item.title,
        datetime: planItem.datetime ? planItem.datetime : planItem.created_task,
        idJob: item.id,
      });
    }

    this.setState({ selectedBulkPlans });
  };

  openBulkSendPlanes = (event) => {
    if (!this.state.selectedBulkPlans || this.state.selectedBulkPlans.length === 0) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.NENHUM_PLANEJAMENTO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    this.compartilhar = false;
    const anchorEl = event && event.currentTarget
      ? event.currentTarget
      : this.state.bulkPlanAnchorEl
        ? this.state.bulkPlanAnchorEl
        : this.state.anchorEl;

    this.setState({
      anchorEl,
      openListPlanes: true,
      menuItemList: [],
      menuItemListItem: null,
      selectedSendPlanes: [],
      bulkPlanAnchorEl: null,
      bulkPlanJob: null,
    });
  };

  selectSendPlanes = (id) => {
    let selPlanes = this.state.selectedSendPlanes;
    let i = selPlanes.indexOf(id);
    if (i > -1) {
      selPlanes.splice(i, 1);
    } else {
      selPlanes.push(id);
    }
    this.setState({ selectedSendPlanes: selPlanes });
  };

  selectSendClients = (id) => {
    let selClients = this.state.selectedSendClients;
    let i = selClients.indexOf(id);
    if (i > -1) {
      selClients.splice(i, 1);
    } else {
      selClients.push(id);
    }
    this.setState({ selectedSendClients: selClients });
  };

  updateStatusTrabalho = (id, status, type, stage) => {
    this.newItem.type = type;
    this.newItem.func = () => {
      let _id = id;
      this.setState({ progress: true });

      let apiUrl = Config.server + '/job_status';
      let method = 'PUT';

      const formData = new URLSearchParams();
      formData.append('id', _id);
      formData.append('status', status);
      if (this.newItem.type) formData.append('type', this.newItem.type);

      let options = {
        method: method,
        body: formData,
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((resData) => {
          if (resData.status !== 200) throw resData;
          else return resData.json();
        })
        .then(
          (result) => {
            this.updateListStatus();
            let tab_state = this.filters.state.filter((item, key) => (key === stage && this.state.tab_state.includes(item.value)));
            let state = { newFunc: false };

            if (this.newItem.type === 'type') {
              state.menuItem = this.state.menuItem;
              state.menuItem.type = status;
            } else if ((status === 'canceled' || status === 'deleted') && this.newItem.type) {
              let i = this.state.menuItemList.findIndex(item => (item.id === _id));
              if (i >= 0) {
                this.state.menuItemList.splice(i, 1);
              }
              state.menuItemList = this.state.menuItemList;
            } else if ((status === 'canceled' && !this.state.tab_state.includes('0')) || status === 'deleted') {
              this.removeItem(_id);
            } else if (status === 'close' && stage !== undefined && tab_state.length === 0) {
              this.removeItem(_id);
            }
            this.setState(state);
          },
          (error) => {
            this.setState({ progress: false });
            if (error.status === 405) {
              notification.open({
                message: this.props.res.PERMISSAO,
                description: this.props.res.PERMISSAO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            } else if (error.status === 401 || error.status === 403) {
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    };
    if ((status === 'canceled' || status === 'deleted') && this.newItem.type !== 'type') {
      if (this.newItem.type === 'link') {
        if (this.state.menuItem['list_analise'] === this.state.menuItemList) {
          this.newItem.type = 'analise';
        } else if (this.state.menuItem['list_check'] === this.state.menuItemList) {
          this.newItem.type = 'appraisal';
        } else if (this.state.menuItem['list_exe'] === this.state.menuItemList) {
          this.newItem.type = 'execucao';
        } else if (this.state.menuItem['list_plan'] === this.state.menuItemList) {
          this.newItem.type = 'planejamento';
        } else {
          return;
        }
      }

      this.newItem.msg = this.props.res.DESEJA_EXCLUIR_ITEM;
      this.setState({ newFunc: true });
    } else {
      this.newItem.func();
      if (this.state.menuItem) {
        let menuItem = this.state.menuItem;
        if (this.newItem.type !== 'type') {
          menuItem.status = status;
        }
        this.setState({ jobList: [...this.state.jobList], menuItem }, () => {
          console.log('menuitem', menuItem);
        });
      }

    }
  };

  getJobValue = (item, paths) => {
    for (let i = 0; i < paths.length; i++) {
      let value = item;

      for (let j = 0; j < paths[i].length; j++) {
        value = value && value[paths[i][j]];
      }

      if (value) return value;
    }

    return '';
  };

  findItemByIdOrName = (list, id, name) => {
    if (id !== null && id !== undefined && id !== '') {
      const itemById = list.find(item => item && Number(item.id) === Number(id));
      if (itemById) return itemById;
    }

    if (name) {
      return list.find(item => item && (String(item.name) === String(name) || String(item.original_name) === String(name))) || null;
    }

    return null;
  };

  updateTitleTrabalho = (id, title) => {
    const item = this.state.menuItem || {};

    const clientName = this.getJobValue(item, [
      ['list_plan', 0, 'client'],
      ['list_exe', 0, 'client_name'],
      ['list_exe', 0, 'client'],
      ['list_os', 0, 'serviceOrder', 'client']
    ]);

    const planeName = this.getJobValue(item, [
      ['list_plan', 0, 'plane'],
      ['list_exe', 0, 'plane_name'],
      ['list_exe', 0, 'plane'],
      ['list_os', 0, 'serviceOrder', 'job', 'plane']
    ]);

    const pilotName = this.getJobValue(item, [
      ['list_plan', 0, 'pilot'],
      ['list_exe', 0, 'pilot'],
      ['list_os', 0, 'serviceOrder', 'job', 'pilot']
    ]);

    const clientId = this.getJobValue(item, [
      ['id_client'],
      ['list_plan', 0, 'id_client'],
      ['list_exe', 0, 'id_client'],
      ['list_os', 0, 'serviceOrder', 'id_client']
    ]);

    const planeId = this.getJobValue(item, [
      ['id_plane'],
      ['list_plan', 0, 'id_plane'],
      ['list_exe', 0, 'id_plane'],
      ['list_os', 0, 'serviceOrder', 'job', 'id_plane']
    ]);

    const pilotId = this.getJobValue(item, [
      ['id_pilot'],
      ['list_plan', 0, 'id_pilot'],
      ['list_exe', 0, 'id_pilot'],
      ['list_os', 0, 'serviceOrder', 'job', 'id_pilot']
    ]);

    const selectedClient = this.findItemByIdOrName(this.state.customers, clientId, clientName);
    const selectedPlane = this.findItemByIdOrName(this.state.editPlanes, planeId, planeName);
    const selectedPilot = this.findItemByIdOrName(this.state.editPilots, pilotId, pilotName);

    let newTitle = {
      id: id,
      atual: title,
      novo: title,
      client: selectedClient && selectedClient.id != null ? String(selectedClient.id) : '',
      plane: selectedPlane && selectedPlane.id != null ? String(selectedPlane.id) : '',
      pilot: selectedPilot && selectedPilot.id != null ? String(selectedPilot.id) : '',
      call: () => {
        let _id = id;
        this.setState({ progress: true });

        let apiUrl = Config.server + '/job_update';
        let method = 'PUT';

        const client = this.state.customers.find(item => item && String(item.id) === String(this.state.newTitle.client));
        const plane = this.state.editPlanes.find(item => item && String(item.id) === String(this.state.newTitle.plane));
        const pilot = this.state.editPilots.find(item => item && String(item.id) === String(this.state.newTitle.pilot));

        const clientName = client && client.name ? client.name : '';
        const planeName = plane && plane.original_name ? plane.original_name : plane && plane.name ? plane.name : '';
        const pilotName = pilot && pilot.original_name ? pilot.original_name : pilot && pilot.name ? pilot.name : '';

        const formData = new URLSearchParams();
        formData.append('id', _id);
        formData.append('title', this.state.newTitle.novo);
        formData.append('id_client', client && client.id != null ? client.id : '');
        formData.append('client', clientName);
        formData.append('id_plane', plane && plane.id != null ? plane.id : '');
        formData.append('plane', planeName);
        formData.append('plane_name', planeName);
        formData.append('plane_company_id', plane && plane.id_company != null ? plane.id_company : '');
        formData.append('id_pilot', pilot && pilot.id != null ? pilot.id : '');
        formData.append('pilot', pilotName);
        formData.append('pilot_name', pilotName);
        formData.append('pilot_company_id', pilot && pilot.id_company != null ? pilot.id_company : '');

        let options = {
          method: method,
          body: formData,
          headers: {
            'Authorization': localStorage.getItem('access-token-jwt')
          }
        }

        fetch(apiUrl, options)
          .then((resData) => {
            if (resData.status !== 200) throw resData;
            else return resData.json();
          })
          .then(
            (result) => {
              let item = this.state.jobList.find(a => (a.id === this.state.menuItem.id));
              if (item) {
                item.title = this.state.newTitle.novo;
                item.id_client = client && client.id != null ? client.id : null;
                item.id_plane = plane && plane.id != null ? plane.id : null;
                item.id_pilot = pilot && pilot.id != null ? pilot.id : null;

                if (item.list_plan && item.list_plan.length > 0) {
                  item.list_plan[0].id_client = client && client.id != null ? client.id : null;
                  item.list_plan[0].client = clientName;
                  item.list_plan[0].client_name = clientName;
                  item.list_plan[0].id_plane = plane && plane.id != null ? plane.id : null;
                  item.list_plan[0].plane = planeName;
                  item.list_plan[0].plane_name = planeName;
                  item.list_plan[0].id_pilot = pilot && pilot.id != null ? pilot.id : null;
                  item.list_plan[0].pilot = pilotName;
                  item.list_plan[0].pilot_name = pilotName;
                }
                if (item.list_exe && item.list_exe.length > 0) {
                  item.list_exe[0].id_client = client && client.id != null ? client.id : null;
                  item.list_exe[0].client = clientName;
                  item.list_exe[0].client_name = clientName;
                  item.list_exe[0].id_plane = plane && plane.id != null ? plane.id : null;
                  item.list_exe[0].plane = planeName;
                  item.list_exe[0].plane_name = planeName;
                  item.list_exe[0].id_pilot = pilot && pilot.id != null ? pilot.id : null;
                  item.list_exe[0].pilot = pilotName;
                  item.list_exe[0].pilot_name = pilotName;
                }
              }
              this.setState({ jobList: [...this.state.jobList], newTitle: false, anchorEl: null });
            },
            (error) => {
              this.setState({ progress: false });
              if (error.status === 405) {
                notification.open({
                  message: this.props.res.PERMISSAO,
                  description: this.props.res.PERMISSAO_MSG,
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              } else if (error.status === 401 || error.status === 403) {
                this.props.link('/login');
              }
              else {
                console.log(error);
                notification.open({
                  message: this.props.res.ERRO,
                  description: this.props.res.ERRO_MSG,
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              }
            }
          );
      }
    }

    this.setState({ newTitle: newTitle });
  };

  runAI = (guid) => {
    let apiUrl = Config.server + '/ai_log/result/' + guid;
    let method = 'GET';

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((resData) => {
        if (resData.status !== 200) throw resData;
        else return resData.json();
      })
      .then(
        (result) => {
          notification.open({
            message: this.props.res.SUCESSO,
            description: 'Análise de IA concluída',
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  removeItem = (id) => {
    let jobList = this.state.jobList;

    let filteredList = jobList.filter(item => (item.id !== id));

    this.setState({ jobList: filteredList });
  };

  groupByDay(jobList) {
    const groups = {};
    const selectedReference = this.state.referencia || 'startDate';

    jobList.forEach((item) => {
      let dateOrder;
      if (selectedReference === 'started') {
        dateOrder = item.list_rel?.length ? item.list_rel[0]?.startDate : null;
      } else if (selectedReference === 'finished') {
        dateOrder = item.list_rel?.length ? item.list_rel[0]?.endDate : null;
      } else {
        dateOrder = item[selectedReference];
      }

      const date = typeof dateOrder === 'string' ? new Date(dateOrder) : new Date(parseInt(dateOrder));

      if (isNaN(date)) {
        return;
      }

      const day = Moment(date).format('YYYY-MM-DD');
      if (!groups[day]) {
        groups[day] = [];
      }
      groups[day].push({ ...item, dateOrder: date });
    });

    return groups;
  }

  exportReport = async () => {
    const filters = {
      dateini: this.state.dateIni.getTime(),
      datefim: this.state.dateEnd.getTime(),
    };

    const apiUrl = `${Config.server}/relReportCSV`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(filters)
      });

      if (!response.ok) {
        if (response.status === 404) {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.MSG_ERRO_PLANILHA,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `relatorio-ciclo-operacao.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    }
  };

  openServiceOrderMenu = async (event, job) => {
    this.setState({
      anchorElSO: event.currentTarget,
      soMenuItem: job,
      soList: [],
      soLoading: true,
      soSearchText: ''
    });

    try {
      let list = [];

      if (job && job.id_service_order) {
        const apiUrl = `${Config.server}/service_order/${job.id_service_order}`;
        const res = await fetch(apiUrl, {
          method: 'GET',
          headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
        });
        if (res.status !== 200) throw res;
        const data = await res.json();
        const os = (data && data.data) ? data.data : data;
        if (os) list = [os];
      } else {
        list = [];
      }

      this.setState({ soList: list });
    } catch (error) {
      console.error(error);
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    } finally {
      this.setState({ soLoading: false });
    }
  };

  closeServiceOrderMenu = () => {
    this.setState({ anchorElSO: null, soMenuItem: null, soList: [] });
  };

  onChangeSoSearch = (e) => {
    const value = e && e.target ? e.target.value : '';
    this.setState({ soSearchText: value });
  };

  searchServiceOrders = async () => {
    const dataRaw = this.state.soSearchText ? String(this.state.soSearchText).trim() : '';
    const dataSearch = dataRaw.length ? dataRaw : '';

    this.setState({ soLoading: true, soList: [] });

    try {
      const apiUrl = `${Config.server}/service_order/search`;
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: dataSearch,
          limit: 100,
          offset: 0
        })
      });

      if (res.status !== 200) throw res;

      const data = await res.json();
      const list = (data && Array.isArray(data.data)) ? data.data : (Array.isArray(data) ? data : []);

      this.setState({ soList: list });
    } catch (error) {
      console.error(error);
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    } finally {
      this.setState({ soLoading: false });
    }
  };

  goToCreateSO = (job) => {
    try {
      if (job?.id_service_order && job?.id_service_order_job) {
        sessionStorage.removeItem('jobOrigin');
      } else {
        sessionStorage.setItem('jobOrigin', JSON.stringify({ job_id: job?.id, job_guid: job?.guid, job_list_analise: job.list_analise, job_list_exe: job.list_exe, job_list_plan: job.list_plan }));
      }
    } catch (_) { }
    this.closeServiceOrderMenu();
    this.openAppPath('/app/ordem-servico/edit');
  };

  goToExistingSO = (osId) => {
    const job = this.state.soMenuItem;
    try {
      if (job?.id_service_order && job?.id_service_order_job) {
        sessionStorage.removeItem('jobOrigin');
      } else {
        sessionStorage.setItem('jobOrigin', JSON.stringify({ job_id: job?.id, job_guid: job?.guid, job_list_analise: job.list_analise, job_list_exe: job.list_exe, job_list_plan: job.list_plan }));
      }
    } catch (_) { }
    this.closeServiceOrderMenu();
    this.openAppPath('/app/ordem-servico/edit/' + osId);
  };

  render() {
    const { res, link, profile } = this.props;
    let clickOut = false;
    return (
      <div className='fullH' >
        <ApplicationReportModal
          ref={this.jobApplicationReportModalRef}
          res={res}
          link={link}
        />
        <KmzModal
          ref={this.jobApplicationKmzModalRef}
          res={res}
          link={link}
        />
        <div style={{
          transform: `scale(${this.state.zoom})`,
          transformOrigin: 'top left',
          height: `${107.729 / Math.pow(this.state.zoom, 0.892814) - 7.75824}%`,
          width: `${105.472 / Math.pow(this.state.zoom, 0.950586) - 5.50128}%`
        }}>
          <div className="divContent" style={{ margin: '1rem' }}>
            <div className="containerTitle">
              <div style={{ height: '1rem 1rem 0rem 1rem' }}><h1>{res.CICLO_OPERACAO}</h1></div>
              <div className="centerTop" style={{ textAlign: 'center', padding: '1rem' }}>
                {res.DATA_REFERENCIA}:
                <Select
                  value={this.state.referencia}
                  onChange={this.handleSelectChange}
                  style={{ margin: '-0.4rem 1rem 0px 0.6rem' }}
                >
                  <MenuItem value="created">
                    {res.CRIACAO_CICLO}
                  </MenuItem>
                  <MenuItem value="updated">
                    {res.ATUALIZACAO_CICLO}
                  </MenuItem>
                  <MenuItem value="started">
                    {res.INICIO_APLICACAO}
                  </MenuItem>
                  <MenuItem value="finished">
                    {res.FIM_APLICACAO}
                  </MenuItem>

                </Select>
                {res.NO_PERIODO_DE}:
                <TextField
                  type="date"
                  value={this.dateToString(this.state.dateIni)}
                  onChange={event => { this.setNewJobs('dateIni', this.stringToDate(event.target.value)) }}
                  style={{ width: '9rem', margin: '-.4rem 1rem 0 .6rem' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {res.ATE}
                <TextField
                  type="date"
                  value={this.dateToString(this.state.dateEnd)}
                  onChange={event => { this.setNewJobs('dateEnd', this.stringToDate(event.target.value)) }}
                  style={{ width: '9rem', margin: '-.4rem 1rem 0 .6rem' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div style={{ display: 'flex', height: '2.8rem' }}>
                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} title={res.INICIAR_PRE_OPERACAO?.toUpperCase()} onClick={(e) => { link('/app/preoperacao') }}>
                  <SvgIcon viewBox="-2 0 26 26" className="iconArrow"
                    style={{ color: 'white', width: '2rem', height: '2rem' }}>
                    <path d="M4,7h16v2H4V7z M4,13h16v-2H4V13z M4,17h7v-2H4V17z M4,21h7v-2H4V21z M15.41,18.17L14,16.75l-1.41,1.41L15.41,21L20,16.42 L18.58,15L15.41,18.17z M4,3v2h16V3H4z" />
                  </SvgIcon>
                </Button>
                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} title={res.INICIAR_PLANO?.toUpperCase()} onClick={(e) => { link('/app/estimativa/new') }}>
                  <SvgIcon viewBox="-2 0 26 26" className="iconArrow"
                    style={{ color: 'white', width: '2rem', height: '2rem' }}>
                    <path d="M2.5,19h19v2h-19V19z M22.07,9.64c-0.21-0.8-1.04-1.28-1.84-1.06L14.92,10l-6.9-6.43L6.09,4.08l4.14,7.17l-4.97,1.33 l-1.97-1.54l-1.45,0.39l2.59,4.49c0,0,7.12-1.9,16.57-4.43C21.81,11.26,22.28,10.44,22.07,9.64z" />
                  </SvgIcon>
                </Button>
                <input
                  accept=".zjob"
                  style={{ display: 'none' }}
                  id="contained-button-file"
                  type="file"
                  onChange={this.loadFile}
                />
                <label htmlFor="contained-button-file">
                  <Button component="span" variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton"
                    title={res.IMPORTAR_EXECUCAO_TRABALHO?.toUpperCase()}>
                    <SvgIcon viewBox="0 0 1000 1000" className="iconArrow"
                      style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                      <path d="M122.513 646.499c3.66376,13.0115 11.813,21.1608 24.4821,24.3451l273.344 0 36.1582 0.47937 25.5093 0 -0.513611 13.662 0  107.002c4.17737,9.51892 9.69012,14.8605 16.504,16.1959 6.84814,1.16418 14.5181,3.97192 23.0098,8.14929 8.14929,-4.17737 15.4768,-6.98511  22.1537,-8.14929 6.67694,-1.33539 12.3267,-6.84814 16.8464,-16.6752l0 -106.523 0 -13.662 25.5093 0 35.6446 -0.47937 273.344 0c12.3267,-3.18439  20.5102,-11.3337 24.4821,-24.3451l-0.47937 -88.8204 -365.828 0 -6.84814 -69.3374 0.992981 10.1695 3.01318 -106.009 16.1616 0 4.34857 145.66  4.31433 -145.66 16.1616 0 4.34857 145.66 4.00616 -145.66 15.9904 0 4.48553 145.66 4.34857 -145.66 10.3407 0c0.992981,-0.513611 1.81476,-0.992981  2.67078,-1.33539 0.821777,-0.342407 1.64355,-0.650574 2.63653,-0.992981l4.34857 147.988 4.48553 -156.822c0.684814,-0.992981 1.19842,-2.67078  1.849,-5.34155l-1.33539 -6.33453 3.83496 -143.16 -18.0106 0 2.84198 102.174 -0.513611 -1.50659 -11.6418 0 3.32135 -100.668 -18.49 0 2.97894  100.668 -12.3267 0 3.01318 -100.668 -18.0106 0 2.84198 100.668 -12.1555 0 2.97894 -100.668 -18.1476 0 2.49957 100.668 -12.1897 0 2.84198 -100.668  -18.0106 0 2.84198 100.668 -1.81476 0c-4.00616,-1.67779 -7.36175,-4.17737 -10.3407,-7.32751l2.97894 -93.3402 -18.1476 0 2.49957  92.8266c-3.01318,3.32135 -6.50574,5.82092 -10.8543,7.84112l-0.821777 0 2.32837 -100.668 -17.9764 0 2.80774 100.668 -12.1555 0 3.01318  -100.668 -18.1818 0 3.01318 100.668 -12.6691 0 2.80774 -100.668 -17.9764 0 2.97894 100.668 -12.3267 0 3.01318 -100.668 -18.1818 0  3.01318 100.668 -12.1555 0 -2.49957 8.8341 1.98596 -7.32751 2.84198 -102.174 -18.0106 0 4.34857 143.16 -1.849 6.33453c-0.342407,-1.33539  0.342407,0.513611 1.849,5.34155l4.99914 156.822 4.31433 -147.988c0,0 1.67779,0.821777 4.82794,2.32837l10.8543 0 4.31433 145.66 4.51977  -145.66 15.9904 0 4.48553 145.66 3.83496 -145.66 16.6752 0 3.83496 145.66 4.34857 -145.66 16.1616 0 2.97894 100.668 -6.33453 64.5095 -365.828  0 -0.47937 88.8204zm19.6542 -419.997l9.17651 311.659 8.8341 -311.659 -18.0106 0zm24.8245 0l8.8341 311.659 9.17651 -311.659 -18.0106  0zm24.3451 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.17651 -311.659 -18.0106 0zm24.3451 0l9.31347 311.659  8.8341 -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.14227 -311.659 -17.9764 0zm24.3109 0l9.34771 311.659 8.8341 -311.659 -18.1818  0zm24.5163 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 -311.659 -18.1818 0zm24.5163 0l9.14227 311.659  9.34771 -311.659 -18.49 0zm135.148 228.488l1.50659 -62.4893 4.34857 0 -5.85516 62.4893zm37.6648 -62.4893l4.86218 0 1.98596 72.3164  -6.84814 -72.3164zm110.837 -9.65588c0,-0.342407 0.171204,-0.513611 0.513611,-0.513611l-0.513611 0.513611zm12.1897 -156.343l9.31347 311.659  8.6629 -311.659 -17.9764 0zm24.8245 0l8.8341 311.659 9.31347 -311.659 -18.1476 0zm24.4821 0l9.34771 311.659 9.17651 -311.659 -18.5242 0zm24.8588 0l9.31347  311.659 8.8341 -311.659 -18.1476 0zm24.4821 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l9.34771 311.659 8.8341 -311.659 -18.1818  0zm24.0027 0l9.17651 311.659 8.8341 -311.659 -18.0106 0zm24.8588 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.4821 0l9.17651 311.659  9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 -311.659 -18.1818 0z" />
                    </SvgIcon>
                  </Button>
                </label>
                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} title={res.PLANILHA_CICLO} onClick={this.exportReport}>
                  <SvgIcon viewBox="0 0 1000 1000" style={{ color: 'white', width: '2rem', height: '2rem', transform: 'rotate(180deg)', }}>
                    <path id="polygon" d="M326.156 867.15l462.329 0c20.0054,0 29.8386,-9.83318 29.8386,-29.8047l0 -633.189c0,-20.0054 -9.83318,-29.8386 -29.8386,-29.8386l-462.329 0c-19.8359,0 -29.8386,9.83318 -29.8386,29.8386l0 633.189c0,19.9715 10.0027,29.8047 29.8386,29.8047zm166.52 -540.486l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm-63.5087 0l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm0 63.0001l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm63.5087 0l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm-63.5087 66.3231l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm63.5087 0l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm68.8322 165.503l98.1622 55.8457c9.83318,-17.3267 14.648,-35.8402 14.648,-55.8457 0,-31.161 -10.986,-57.8123 -32.992,-79.6487 -22.006,-22.006 -48.4877,-32.992 -79.8183,-32.992 -31.161,0 -57.8462,10.986 -79.8522,32.992 -22.006,21.8364 -32.992,48.4877 -32.992,79.6487 0,31.0254 10.986,57.5071 32.992,79.6826 22.006,22.1755 48.6912,33.1615 79.8522,33.1615l0 -112.844zm20.9887 31.3305l9.83318 112.336c34.5178,-3.32294 61.8473,-18.8187 81.9883,-46.8263l-91.8215 -65.5093zm-237.319 163.163l0 -587.99 426.828 0 0 587.99 -426.828 0zm-96.6703 4.84877l47.8096 0 0 -44.0119 -31.161 0 0 -504.306 31.161 0 0 -46.0125 -47.8096 0c-16.852,0 -25.3289,8.68032 -25.3289,26.0071l0 542.825c0,16.9877 8.47688,25.4984 25.3289,25.4984z" />
                  </SvgIcon>
                </Button>
                <div style={{ display: 'flex' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginRight: '.4rem', backgroundColor: this.state.bulkSendMode ? '#283593' : undefined }}
                    title={res.ENVIAR_PLANEJAMENTO_AERONAVE}
                    onClick={this.handleBulkSendButton}
                  >
                    <SvgIcon viewBox="0 96 960 960" style={{ color: 'white', width: '2rem', height: '2rem' }}>
                      <path d="M253.308 875.999q-80.877 0-137.092-56.562-56.214-56.562-56.214-137.13 0-74.384 49.538-129.614 49.538-55.231 122.461-62.23 11.923-81.693 77.577-145.039 65.653-63.346 148.346-63.346 18.23 0 31.807 10.423 13.576 10.423 13.576 27.653v304.77l87.231-87.615 32.615 32.999-142.538 142.153-142.152-142.153 32.614-32.999 86.847 87.615V324q-82.923 6.385-135.193 70.692Q270.462 459 270.462 534.385h-19.385q-60.044 0-102.868 42.615t-42.824 105.692q0 63.077 43.846 105.5t104.183 42.423h494.509q44.231 0 75.461-31.293 31.231-31.293 31.231-75.269 0-43.976-31.231-75.207-31.23-31.231-75.597-31.231h-62.095v-83.23q0-63-29.923-110.384-29.923-47.385-77.691-75.616v-49.999q70.614 28.616 111.806 93.308 41.192 64.691 41.192 142.691v37.847h12.308q65.461-2.385 111.038 40.999 45.577 43.385 45.577 110.692 0 62.461-44.808 107.268-44.807 44.808-107.268 44.808H253.308ZM480 555.539Z" />
                    </SvgIcon>
                  </Button>
                  <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} title={'ZOOM'} onClick={event => { this.handleClickAdd(event, 'anchorElAdd') }}>
                    <SvgIcon viewBox="0 -960 960 960" className="iconArrow"
                      style={{ color: 'white', width: '2rem', height: '2rem' }}>
                      <path d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z" />
                    </SvgIcon>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div style={{ margin: '1rem', position: 'relative' }}>
            <div style={{ position: 'absolute', marginTop: '1rem' }}>
              <div className='divContent' onClick={this.hasOnlineFarmMapAccess() ? this.openOnlineFarmMap3D : undefined} title={this.hasOnlineFarmMapAccess() ? res.MAPA_FAZENDA_ONLINE : res.NENHUM_TRABALHO_EXECUCAO_HOJE} style={Object.assign({ borderRadius: '.8rem', width: '15rem', height: '6.3rem', textAlign: 'center', backgroundColor: '#343a40', color: 'white' }, this.hasOnlineFarmMapAccess() ? { cursor: 'pointer' } : { cursor: 'not-allowed' })}>
                {res.MAPA_FAZENDA_ONLINE}
                <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center' }}>
                  <div style={{ display: 'flex', gap: '.5rem' }}>
                    <div style={{ display: 'flex', gap: '.8rem', justifyContent: 'center', marginTop: '.7rem' }}>
                      <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{this.state.onlinePlanes}</h2>
                      <SvgIcon viewBox="0 0 800 800" className="iconArrow" style={{ color: 'white', width: '1.7rem', height: '1.7rem', marginTop: '.5rem' }}>
                        <path d="M 0 156.81 L 0 0 L 65.28 0 L 125.41 103.72 L 243.59 87.54 C 260.71 67.18 282.02 49.29 307.72 33.88 C 333.41 18.46 354.72 10.66 371.85 10.66  L 381.93 10.66 C 395.25 10.28 409.14 19.04 423.8 36.54 C 438.26 54.24 448.73 67.56 455.58 76.51 L 734.36 95.92 L 734.36 21.32 L 753.2 21.32 L 753.2  116.66 C 757.39 116.66 762.34 117.61 768.62 119.7 C 774.71 121.8 777.75 123.89 777.75 126.17 C 777.75 128.65 774.71 132.07 768.62 136.45 C 762.34  140.64 757.58 142.73 753.77 142.73 L 753.77 242.06 L 734.74 242.06 L 734.74 168.99 L 569.18 208 L 569.18 251.01 C 583.46 256.15 590.5 266.23 590.5  281.08 C 590.5 302.58 579.84 313.43 558.72 313.43 C 537.02 313.43 526.37 302.58 526.37 281.08 C 526.37 265.47 533.98 255.19 549.2 250.44 L 549.2 210.29  L 501.82 225.89 L 384.78 225.89 L 0 156.81 Z M 23.98 430.46 C 23.98 416.38 30.83 409.34 44.53 409.34 C 58.81 409.34 65.85 416.38 65.85 430.46 C 65.85  444.16 58.81 451.2 44.53 451.2 C 30.83 451.2 23.98 444.16 23.98 430.46 Z M 26.83 579.27 C 26.83 565.19 33.88 558.15 47.96 558.15 C 61.66 558.15 68.51  565.19 68.51 579.27 C 68.51 593.16 61.66 600.01 47.96 600.01 C 33.88 600.01 26.83 593.16 26.83 579.27 Z M 65.85 652.92 C 65.85 639.22 72.89 632.37  86.97 632.37 C 100.67 632.37 107.71 639.22 107.71 652.92 C 107.71 667 100.67 674.04 86.97 674.04 C 72.89 674.04 65.85 667 65.85 652.92 Z M 66.42 504.11  C 66.42 490.02 73.46 482.98 87.54 482.98 C 101.24 482.98 108.09 490.02 108.09 504.11 C 108.09 517.81 101.24 524.66 87.54 524.66 C 73.46 524.66 66.42  517.81 66.42 504.11 Z M 106.57 430.46 C 106.57 416.38 113.61 409.34 127.69 409.34 C 141.39 409.34 148.24 416.38 148.24 430.46 C 148.24 444.16 141.39  451.2 127.69 451.2 C 113.61 451.2 106.57 444.16 106.57 430.46 Z M 109.23 579.27 C 109.23 565.19 116.28 558.15 130.55 558.15 C 144.25 558.15 151.1  565.19 151.1 579.27 C 151.1 593.16 144.25 600.01 130.55 600.01 C 116.28 600.01 109.23 593.16 109.23 579.27 Z M 148.24 652.92 C 148.24 639.22 155.29  632.37 169.56 632.37 C 183.26 632.37 190.11 639.22 190.11 652.92 C 190.11 667 183.26 674.04 169.56 674.04 C 155.29 674.04 148.24 667 148.24 652.92  Z M 149.39 504.11 C 149.39 490.02 156.24 482.98 170.13 482.98 C 183.83 482.98 190.68 490.02 190.68 504.11 C 190.68 517.81 183.83 524.66 170.13 524.66  C 156.24 524.66 149.39 517.81 149.39 504.11 Z M 151.1 355.86 C 151.1 341.97 157.95 335.12 171.65 335.12 C 185.92 335.12 192.97 341.97 192.97 355.86  C 192.97 369.95 185.92 376.99 171.65 376.99 C 157.95 376.99 151.1 369.95 151.1 355.86 Z M 188.97 430.46 C 188.97 416.38 196.01 409.34 210.28 409.34  C 223.98 409.34 230.83 416.38 230.83 430.46 C 230.83 444.16 223.98 451.2 210.28 451.2 C 196.01 451.2 188.97 444.16 188.97 430.46 Z M 192.39 579.27  C 192.39 565.19 199.25 558.15 212.95 558.15 C 226.65 558.15 233.69 565.19 233.69 579.27 C 233.69 593.16 226.65 600.01 212.95 600.01 C 199.25 600.01  192.39 593.16 192.39 579.27 Z M 231.41 652.92 C 231.41 639.22 238.26 632.37 251.96 632.37 C 266.23 632.37 273.27 639.22 273.27 652.92 C 273.27 667 266.23  674.04 251.96 674.04 C 238.26 674.04 231.41 667 231.41 652.92 Z M 231.98 504.11 C 231.98 490.02 238.83 482.98 252.53 482.98 C 266.61 482.98 273.84 490.02  273.84 504.11 C 273.84 517.81 266.61 524.66 252.53 524.66 C 238.83 524.66 231.98 517.81 231.98 504.11 Z M 233.69 355.86 C 233.69 341.97 240.54 335.12  254.24 335.12 C 268.32 335.12 275.36 341.97 275.36 355.86 C 275.36 369.95 268.32 376.99 254.24 376.99 C 240.54 376.99 233.69 369.95 233.69 355.86 Z M  272.13 430.46 C 272.13 416.38 278.98 409.34 292.68 409.34 C 306.76 409.34 313.81 416.38 313.81 430.46 C 313.81 444.16 306.76 451.2 292.68 451.2 C 278.98  451.2 272.13 444.16 272.13 430.46 Z M 274.79 579.27 C 274.79 565.19 281.83 558.15 295.54 558.15 C 309.62 558.15 316.66 565.19 316.66 579.27 C 316.66 593.16  309.62 600.01 295.54 600.01 C 281.83 600.01 274.79 593.16 274.79 579.27 Z M 277.08 284.5 C 277.08 270.23 283.93 263.19 297.82 263.19 C 311.9 263.19 318.94  270.23 318.94 284.5 C 318.94 298.2 311.9 305.05 297.82 305.05 C 283.93 305.05 277.08 298.2 277.08 284.5 Z M 313.81 652.92 C 313.81 639.22 321.04 632.37  335.12 632.37 C 348.82 632.37 355.67 639.22 355.67 652.92 C 355.67 667 348.82 674.04 335.12 674.04 C 321.04 674.04 313.81 667 313.81 652.92 Z M 314.38  504.11 C 314.38 490.02 321.61 482.98 335.69 482.98 C 349.39 482.98 356.24 490.02 356.24 504.11 C 356.24 517.81 349.39 524.66 335.69 524.66 C 321.61 524.66  314.38 517.81 314.38 504.11 Z M 316.09 355.86 C 316.09 341.97 323.13 335.12 337.4 335.12 C 351.1 335.12 357.95 341.97 357.95 355.86 C 357.95 369.95 351.1  376.99 337.4 376.99 C 323.13 376.99 316.09 369.95 316.09 355.86 Z M 345.58 76.51 L 418.66 76.51 L 382.5 39.21 L 345.58 39.21 L 345.58 76.51 Z M 354.53  430.46 C 354.53 416.38 361.38 409.34 375.27 409.34 C 389.35 409.34 396.39 416.38 396.39 430.46 C 396.39 444.16 389.35 451.2 375.27 451.2 C 361.38 451.2  354.53 444.16 354.53 430.46 Z M 357.38 579.27 C 357.38 565.19 364.42 558.15 378.51 558.15 C 392.4 558.15 399.25 565.19 399.25 579.27 C 399.25 593.16 392.4  600.01 378.51 600.01 C 364.42 600.01 357.38 593.16 357.38 579.27 Z M 359.67 284.5 C 359.67 270.23 366.71 263.19 380.79 263.19 C 394.49 263.19 401.34 270.23  401.34 284.5 C 401.34 298.2 394.49 305.05 380.79 305.05 C 366.71 305.05 359.67 298.2 359.67 284.5 Z M 369.18 143.87 C 387.26 149.58 405.53 152.82 423.99  153.96 C 442.44 155.1 461.1 155.67 480.12 155.67 C 498.58 155.29 516.85 154.34 534.74 152.82 C 552.44 151.29 570.13 147.3 587.64 140.64 C 568.99 134.93  550.73 131.31 532.65 129.79 C 514.76 128.08 496.87 126.74 479.55 126.17 C 432.36 128.65 395.44 134.55 369.18 143.87 Z M 396.96 504.11 C 396.96 490.02 404.01  482.98 418.09 482.98 C 431.98 482.98 438.83 490.02 438.83 504.11 C 438.83 517.81 431.98 524.66 418.09 524.66 C 404.01 524.66 396.96 517.81 396.96 504.11 Z  M 398.68 355.86 C 398.68 341.97 405.72 335.12 419.8 335.12 C 433.5 335.12 440.54 341.97 440.54 355.86 C 440.54 369.95 433.5 376.99 419.8 376.99 C 405.72  376.99 398.68 369.95 398.68 355.86 Z M 437.12 430.46 C 437.12 416.38 444.16 409.34 458.24 409.34 C 472.13 409.34 478.98 416.38 478.98 430.46 C 478.98 444.16  472.13 451.2 458.24 451.2 C 444.16 451.2 437.12 444.16 437.12 430.46 Z M 442.06 284.5 C 442.06 270.23 449.11 263.19 463.38 263.19 C 477.08 263.19 483.93  270.23 483.93 284.5 C 483.93 298.2 477.08 305.05 463.38 305.05 C 449.11 305.05 442.06 298.2 442.06 284.5 Z" />
                      </SvgIcon>
                    </div>
                    <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center', marginTop: '.7rem' }}>
                      <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{this.state.onlineSources}</h2>
                      <SvgIcon viewBox="0 0 650 650" className="iconArrow" style={{ color: 'white', width: '1.7rem', height: '1.7rem', marginTop: '.2rem' }}>
                        <path d="M255.45 464.62l37.89 0.41c4.71,21.27 -7.9,62.41 15.7,62.28 23.4,-0.12 11.11,-41.07 15.74,-61.78l36.73 -0.85c8.08,10.38 45.84,85.26 47.65,97.46l-201.48 0.07 47.77 -97.59zm46.58 -216.13c19.1,-11.8 33.45,19.1 16.28,28.44 -10,5.44 -20.98,0.89 -24.38,-5.86 -6.88,-13.63 1.87,-18.73 8.1,-22.58zm-7.51 92.68c-30.28,5.24 -102.61,1.04 -137.45,1.16 -28.13,0.09 -80.16,2.48 -84.84,-50.61 -5.41,-61.28 62.01,-59.54 68.03,-68.75 8.75,-13.4 -2.57,-26.63 20.49,-48.67 12.28,-11.74 28.49,-18.02 50.96,-13.58 29.58,5.84 22.13,-3.79 44.02,-15.83 44.25,-24.33 111.43,-1.42 116.63,67.3 2.1,27.71 17.76,19.06 33.38,35.75 32.12,34.3 12.47,112.43 -82.29,93.05l0.3 -34.29c11.23,-7.41 15.18,-7.19 22.83,-18.4 19.41,-28.43 1.34,-71.07 -37.59,-71.2 -41.42,-0.14 -71.52,58.11 -14.35,89.3l-0.12 34.78zm104.11 -158.27c39.43,-2.22 59.15,33.49 51.79,59.91l-6.05 11.81 -7.14 -10.68c-2.7,-4.7 -2.34,-4.71 -5.22,-8.46 -19.35,-25.26 -36.17,-18.89 -33.39,-52.57zm-73.72 253.62c-3.41,-13.48 -1.39,-30.82 -1.59,-45.08 -0.33,-23.22 -1.67,-21.37 21.42,-20.91 99.4,1.99 95.44,-61.52 105.74,-77.98 4.17,-6.66 13.31,-12.1 20.04,-23.93 5.44,-9.55 9.55,-20.96 10.04,-34.44 1.02,-27.86 -14.05,-51.27 -28.51,-62.92 -30.3,-24.42 -60.26,-12.77 -68.67,-17.55 -5.96,-3.38 -19.18,-27.39 -51.03,-39.5 -56.82,-21.6 -85.58,6.54 -105.64,15.63 -10.93,4.95 -28.51,0.05 -42.04,1.99 -57.23,8.2 -66.22,63.16 -70.13,68 -3.96,4.89 -22.8,9.43 -30.43,13.97 -68.85,41 -43.57,147.64 31.45,155.97 54.89,6.1 121.74,-2.96 179.03,1.44l-1.45 65.42 -56.14 2.03c-12.36,21.76 -24,47.22 -36.3,71.28 -50.59,98.89 -51.38,80.98 105.56,80.98 134.52,0 159.61,14.03 131.26,-40.54 -15.6,-30.02 -42.94,-91.11 -56.83,-112.75l-55.77 -1.11zM394.84 120.15c19.79,4.04 22.14,-2.68 22.66,-21.17 0.34,-11.89 3.41,-32.2 -8.02,-37.42 -27.47,-12.55 -24.83,42.93 -14.64,58.59zM513.94 239.43c12.16,8.01 72.45,14.9 58.84,-14.48 -4.94,-10.65 -24.17,-8.38 -37.43,-8.07 -18.44,0.44 -24.72,2.99 -21.41,22.55zM475.82 319.8c0.46,5.33 19.61,23.56 23.67,27.75 16.59,17.15 53.12,6.53 3.61,-36.91 -11.97,-10.5 -28.6,-6.16 -27.27,9.16zM479.38 154.97c17.79,6.42 23.74,-4.19 32.86,-13.15 8.7,-8.54 19.43,-15.6 12.96,-32.63 -18.51,-6.88 -23.65,3.06 -32.87,12.69 -8.59,8.97 -19.49,15.77 -12.95,33.1z" />
                      </SvgIcon>
                    </div>
                  </div>
                  <SvgIcon viewBox="0 96 960 960" style={{ width: '2.5rem', height: '2.5rem', marginLeft: '.5rem', marginTop: '.5rem' }}>
                    <path d="m612 936-263-93-179 71q-17 9-33.5-1T120 883V325q0-13 7.5-23t19.5-15l202-71 263 92 178-71q17-8 33.5 1.5T840 268v565q0 11-7.5 19T814 864l-202 72Zm-34-75V356l-196-66v505l196 66Zm60 0 142-47V302l-142 54v505Zm-458-12 142-54V290l-142 47v512Zm458-493v505-505Zm-316-66v505-505Z" />
                  </SvgIcon>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                <div className='divContent' style={{ borderRadius: '.8rem', width: '7rem', height: '6.3rem', textAlign: 'center', backgroundColor: '#343a40', color: 'white' }}>
                  {res.TRABALHOS}
                  <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center', marginTop: '.5rem' }}>
                    <h2 style={{ color: '#fa7d34' }}>{this.state.qtdJobs}</h2>
                    <SvgIcon viewBox="0 96 960 960" style={{ width: '1.7rem', height: '1.7rem' }}>
                      <path d="M140 936q-24 0-42-18t-18-42V505h60v371h452v60H140Zm121-120q-24 0-42.5-18T200 756V385h60v371h453v60H261Zm119-120q-24 0-42-18t-18-42V276q0-24 18-42t42-18h440q24 0 42 18t18 42v360q0 24-18 42t-42 18H380Zm0-60h440V338H380v298Z" />
                    </SvgIcon>
                  </div>
                </div>
                <div className='divContent' style={{ borderRadius: '.8rem', width: '7rem', height: '6.3rem', textAlign: 'center', backgroundColor: '#343a40', color: 'white' }}>
                  {res.ALERTA_}
                  <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center', marginTop: '.5rem' }}>
                    <h2 style={{ color: '#fa7d34' }}>0</h2>
                    <SvgIcon viewBox="0 0 1000 1000" className="iconArrow" style={{ color: 'white', width: '2rem', height: '2rem', marginTop: '.3rem' }}>
                      <path d="M586.355,182.317c-11.802-11.42-26.394-18.577-41.949-20.772V23.857c0-6.541-3.828-12.479-9.787-15.179 c-5.959-2.703-12.944-1.665-17.865,2.646C414.567,100.896,227.792,122.439,202.741,124.96c-0.364-0.025-0.724-0.056-1.096-0.056 l-90.516-0.015h-0.003c-0.258,0-0.515,0.006-0.771,0.017c-0.151-0.001-0.304-0.001-0.456-0.001l-0.489,0.003 C48.051,125.945-1.025,180.521,0.016,246.563c0.493,31.404,12.161,60.895,32.854,83.042 c21.034,22.508,48.937,34.903,78.572,34.903c0.546,0,23.391-0.013,23.391-0.013l55.369,190.359 c0.142,0.489,0.304,0.965,0.489,1.432c5.823,17.345,17.904,31.592,34.111,40.193c10.408,5.523,21.788,8.33,33.272,8.329 c6.779,0,13.598-0.979,20.269-2.953c17.973-5.318,32.888-17.266,41.999-33.643c8.927-16.048,11.312-34.593,6.748-52.334 c-0.089-0.422-0.193-0.843-0.315-1.261l-39.778-136.765c69.632,14.518,166.001,43.54,229.755,99.424 c3.1,2.717,7.023,4.132,10.989,4.132c2.33,0,4.673-0.487,6.876-1.486c5.96-2.701,9.787-8.639,9.787-15.18V326.553 c38.631-5.366,68.256-41.135,67.582-83.81C611.627,219.761,602.285,197.736,586.355,182.317z M268.888,569.892 c-19.572,5.794-40.564-5.315-46.779-24.767c-0.051-0.164-0.106-0.325-0.162-0.485l-52.398-180.145h31.398 c3.426,0.296,22.026,2.019,49.35,6.514l44.226,152.059c0.046,0.194,0.094,0.386,0.146,0.578 C300.03,543.354,288.466,564.099,268.888,569.892z M123.023,158.223l61.952,0.011v172.93h-61.952V158.223z M89.691,327.691 c-31.954-10.411-55.741-43.064-56.348-81.651c-0.629-39.91,23.353-73.991,56.348-84.478V327.691z M511.071,430.582 c-47.283-33.111-109.453-59.344-185.378-78.172c-46.914-11.633-86.64-17.234-107.385-19.637V156.784 c20.835-2.518,60.494-8.304,107.277-20.074c75.999-19.126,138.201-45.528,185.487-78.681V430.582z M544.405,292.656v-97.158 c6.871,1.833,13.318,5.497,18.767,10.769c9.619,9.312,15.266,22.799,15.488,37C579.038,267.197,564.279,287.495,544.405,292.656z" />
                    </SvgIcon>
                  </div>
                </div>
              </div>
            </div>
            {/*this.state.selectedPlanes.length === 0 ?
            <div style={{ position: 'absolute', top: '.5rem', left: '15.5rem', width: '9rem', height: '14.5rem', border: 'solid 4px #fa7d34', borderRadius: '1.2rem' }}></div>
            : null*/}
            <div id="planes" style={{ width: 'calc(100% - 16rem)', marginLeft: '16rem', paddingTop: '1rem', marginTop: '-.75rem', overflow: 'auto' }}>
              <div style={{ width: '20rem', height: '14rem', display: 'flex', gap: '1.4em' }}>
                <div className='divContent' onClick={event => { this.changePlanes() }} style={{
                  cursor: 'pointer', position: 'relative', display: 'flex',
                  justifyContent: 'center', flexWrap: 'wrap', padding: '2rem', borderRadius: '.8rem', minWidth: '8rem', width: '8rem', height: '13.5rem', backgroundColor:
                    this.state.selectedPlanes.length === 0 ? '#343a40' : '#f5f5f5', color:
                    this.state.selectedPlanes.length === 0 ? '#f5f5f5' : '#343a40'

                }}>
                  <SvgIcon viewBox="0 0 800 800" className="iconArrow" style={{
                    color:
                      this.state.selectedPlanes.length === 0 ? '#f5f5f5' : '#343a40', width: '1.5rem', height: '1.5rem'
                  }}>
                    <path d="M 0 156.81 L 0 0 L 65.28 0 L 125.41 103.72 L 243.59 87.54 C 260.71 67.18 282.02 49.29 307.72 33.88 C 333.41 18.46 354.72 10.66 371.85 10.66  L 381.93 10.66 C 395.25 10.28 409.14 19.04 423.8 36.54 C 438.26 54.24 448.73 67.56 455.58 76.51 L 734.36 95.92 L 734.36 21.32 L 753.2 21.32 L 753.2  116.66 C 757.39 116.66 762.34 117.61 768.62 119.7 C 774.71 121.8 777.75 123.89 777.75 126.17 C 777.75 128.65 774.71 132.07 768.62 136.45 C 762.34  140.64 757.58 142.73 753.77 142.73 L 753.77 242.06 L 734.74 242.06 L 734.74 168.99 L 569.18 208 L 569.18 251.01 C 583.46 256.15 590.5 266.23 590.5  281.08 C 590.5 302.58 579.84 313.43 558.72 313.43 C 537.02 313.43 526.37 302.58 526.37 281.08 C 526.37 265.47 533.98 255.19 549.2 250.44 L 549.2 210.29  L 501.82 225.89 L 384.78 225.89 L 0 156.81 Z M 23.98 430.46 C 23.98 416.38 30.83 409.34 44.53 409.34 C 58.81 409.34 65.85 416.38 65.85 430.46 C 65.85  444.16 58.81 451.2 44.53 451.2 C 30.83 451.2 23.98 444.16 23.98 430.46 Z M 26.83 579.27 C 26.83 565.19 33.88 558.15 47.96 558.15 C 61.66 558.15 68.51  565.19 68.51 579.27 C 68.51 593.16 61.66 600.01 47.96 600.01 C 33.88 600.01 26.83 593.16 26.83 579.27 Z M 65.85 652.92 C 65.85 639.22 72.89 632.37  86.97 632.37 C 100.67 632.37 107.71 639.22 107.71 652.92 C 107.71 667 100.67 674.04 86.97 674.04 C 72.89 674.04 65.85 667 65.85 652.92 Z M 66.42 504.11  C 66.42 490.02 73.46 482.98 87.54 482.98 C 101.24 482.98 108.09 490.02 108.09 504.11 C 108.09 517.81 101.24 524.66 87.54 524.66 C 73.46 524.66 66.42  517.81 66.42 504.11 Z M 106.57 430.46 C 106.57 416.38 113.61 409.34 127.69 409.34 C 141.39 409.34 148.24 416.38 148.24 430.46 C 148.24 444.16 141.39  451.2 127.69 451.2 C 113.61 451.2 106.57 444.16 106.57 430.46 Z M 109.23 579.27 C 109.23 565.19 116.28 558.15 130.55 558.15 C 144.25 558.15 151.1  565.19 151.1 579.27 C 151.1 593.16 144.25 600.01 130.55 600.01 C 116.28 600.01 109.23 593.16 109.23 579.27 Z M 148.24 652.92 C 148.24 639.22 155.29  632.37 169.56 632.37 C 183.26 632.37 190.11 639.22 190.11 652.92 C 190.11 667 183.26 674.04 169.56 674.04 C 155.29 674.04 148.24 667 148.24 652.92  Z M 149.39 504.11 C 149.39 490.02 156.24 482.98 170.13 482.98 C 183.83 482.98 190.68 490.02 190.68 504.11 C 190.68 517.81 183.83 524.66 170.13 524.66  C 156.24 524.66 149.39 517.81 149.39 504.11 Z M 151.1 355.86 C 151.1 341.97 157.95 335.12 171.65 335.12 C 185.92 335.12 192.97 341.97 192.97 355.86  C 192.97 369.95 185.92 376.99 171.65 376.99 C 157.95 376.99 151.1 369.95 151.1 355.86 Z M 188.97 430.46 C 188.97 416.38 196.01 409.34 210.28 409.34  C 223.98 409.34 230.83 416.38 230.83 430.46 C 230.83 444.16 223.98 451.2 210.28 451.2 C 196.01 451.2 188.97 444.16 188.97 430.46 Z M 192.39 579.27  C 192.39 565.19 199.25 558.15 212.95 558.15 C 226.65 558.15 233.69 565.19 233.69 579.27 C 233.69 593.16 226.65 600.01 212.95 600.01 C 199.25 600.01  192.39 593.16 192.39 579.27 Z M 231.41 652.92 C 231.41 639.22 238.26 632.37 251.96 632.37 C 266.23 632.37 273.27 639.22 273.27 652.92 C 273.27 667 266.23  674.04 251.96 674.04 C 238.26 674.04 231.41 667 231.41 652.92 Z M 231.98 504.11 C 231.98 490.02 238.83 482.98 252.53 482.98 C 266.61 482.98 273.84 490.02  273.84 504.11 C 273.84 517.81 266.61 524.66 252.53 524.66 C 238.83 524.66 231.98 517.81 231.98 504.11 Z M 233.69 355.86 C 233.69 341.97 240.54 335.12  254.24 335.12 C 268.32 335.12 275.36 341.97 275.36 355.86 C 275.36 369.95 268.32 376.99 254.24 376.99 C 240.54 376.99 233.69 369.95 233.69 355.86 Z M  272.13 430.46 C 272.13 416.38 278.98 409.34 292.68 409.34 C 306.76 409.34 313.81 416.38 313.81 430.46 C 313.81 444.16 306.76 451.2 292.68 451.2 C 278.98  451.2 272.13 444.16 272.13 430.46 Z M 274.79 579.27 C 274.79 565.19 281.83 558.15 295.54 558.15 C 309.62 558.15 316.66 565.19 316.66 579.27 C 316.66 593.16  309.62 600.01 295.54 600.01 C 281.83 600.01 274.79 593.16 274.79 579.27 Z M 277.08 284.5 C 277.08 270.23 283.93 263.19 297.82 263.19 C 311.9 263.19 318.94  270.23 318.94 284.5 C 318.94 298.2 311.9 305.05 297.82 305.05 C 283.93 305.05 277.08 298.2 277.08 284.5 Z M 313.81 652.92 C 313.81 639.22 321.04 632.37  335.12 632.37 C 348.82 632.37 355.67 639.22 355.67 652.92 C 355.67 667 348.82 674.04 335.12 674.04 C 321.04 674.04 313.81 667 313.81 652.92 Z M 314.38  504.11 C 314.38 490.02 321.61 482.98 335.69 482.98 C 349.39 482.98 356.24 490.02 356.24 504.11 C 356.24 517.81 349.39 524.66 335.69 524.66 C 321.61 524.66  314.38 517.81 314.38 504.11 Z M 316.09 355.86 C 316.09 341.97 323.13 335.12 337.4 335.12 C 351.1 335.12 357.95 341.97 357.95 355.86 C 357.95 369.95 351.1  376.99 337.4 376.99 C 323.13 376.99 316.09 369.95 316.09 355.86 Z M 345.58 76.51 L 418.66 76.51 L 382.5 39.21 L 345.58 39.21 L 345.58 76.51 Z M 354.53  430.46 C 354.53 416.38 361.38 409.34 375.27 409.34 C 389.35 409.34 396.39 416.38 396.39 430.46 C 396.39 444.16 389.35 451.2 375.27 451.2 C 361.38 451.2  354.53 444.16 354.53 430.46 Z M 357.38 579.27 C 357.38 565.19 364.42 558.15 378.51 558.15 C 392.4 558.15 399.25 565.19 399.25 579.27 C 399.25 593.16 392.4  600.01 378.51 600.01 C 364.42 600.01 357.38 593.16 357.38 579.27 Z M 359.67 284.5 C 359.67 270.23 366.71 263.19 380.79 263.19 C 394.49 263.19 401.34 270.23  401.34 284.5 C 401.34 298.2 394.49 305.05 380.79 305.05 C 366.71 305.05 359.67 298.2 359.67 284.5 Z M 369.18 143.87 C 387.26 149.58 405.53 152.82 423.99  153.96 C 442.44 155.1 461.1 155.67 480.12 155.67 C 498.58 155.29 516.85 154.34 534.74 152.82 C 552.44 151.29 570.13 147.3 587.64 140.64 C 568.99 134.93  550.73 131.31 532.65 129.79 C 514.76 128.08 496.87 126.74 479.55 126.17 C 432.36 128.65 395.44 134.55 369.18 143.87 Z M 396.96 504.11 C 396.96 490.02 404.01  482.98 418.09 482.98 C 431.98 482.98 438.83 490.02 438.83 504.11 C 438.83 517.81 431.98 524.66 418.09 524.66 C 404.01 524.66 396.96 517.81 396.96 504.11 Z  M 398.68 355.86 C 398.68 341.97 405.72 335.12 419.8 335.12 C 433.5 335.12 440.54 341.97 440.54 355.86 C 440.54 369.95 433.5 376.99 419.8 376.99 C 405.72  376.99 398.68 369.95 398.68 355.86 Z M 437.12 430.46 C 437.12 416.38 444.16 409.34 458.24 409.34 C 472.13 409.34 478.98 416.38 478.98 430.46 C 478.98 444.16  472.13 451.2 458.24 451.2 C 444.16 451.2 437.12 444.16 437.12 430.46 Z M 442.06 284.5 C 442.06 270.23 449.11 263.19 463.38 263.19 C 477.08 263.19 483.93  270.23 483.93 284.5 C 483.93 298.2 477.08 305.05 463.38 305.05 C 449.11 305.05 442.06 298.2 442.06 284.5 Z" />
                  </SvgIcon>
                  <div style={{ textAlign: 'center' }}>
                    {res.TODOS}
                    <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center' }}>
                      <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{this.state.planeValues.qtd_total}</h2>
                      <MaterialIcon icon="autorenew" style={{ marginTop: '.3rem', height: '1.5rem' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center' }}>
                      <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{this.state.planeValues.qtd_sended}</h2>
                      <MaterialIcon icon="wysiwyg" style={{ marginTop: '.3rem' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'center' }}>
                      <h2 style={{ color: '#fa7d34', marginBottom: '0' }}>{this.state.planeValues.qtd_received}</h2>
                      <MaterialIcon icon="emoji_flags" style={{ marginTop: '.3rem' }} />
                    </div>
                  </div>
                </div>
                {this.state.planes.map((item, key) =>
                  this.CompPlane(key, item)
                )}
              </div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '16rem auto', height: 'calc(100% - 23.7rem)', overflow: 'hidden' }}>
            <div className='divContent' style={{ padding: '0', position: 'relative', marginLeft: '1rem', height: 'calc(100% - 1rem)', maxHeight: '57rem'/*30rem*/, overflow: 'auto' }}>
              <List
                component="nav"
                aria-labelledby={res.AREAS}
                style={{ position: 'absolute', width: '100%' }}
              >
                <TextFiltro call={(filtro) => { this.setNewJobs('filtro', filtro) }} res={res} />

                <div className="divider" style={{ marginTop: '1rem' }}></div>

                <div key={"T_divpa"} style={{ display: 'flex', height: '2.5rem' }}>
                  <ListItem key={'Tpa1'} button
                    className={this.state.tab_state.length === 0 && this.state.tab_missing.length === 0 && this.state.tab_type.length === 0 ? 'SelItemFull' : ''}
                    disabled={this.filters.todos.disabled}
                    onClick={this.setAllJobs}
                    title={this.filters.todos.label}
                  >
                    <ListItemText id={'Todos'} primary={this.filters.todos.label} style={{ textAlign: 'center' }} />
                  </ListItem>
                </div>

                <div className="divider" style={{ marginTop: '1rem' }}></div>
                <div className="divider" style={{ marginTop: '.5rem', position: 'relative', textAlign: 'center' }}>
                  <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '-1.2rem', width: 'fit-content', backgroundColor: 'white', padding: '0 .5rem', fontWeight: 'bold' }}>
                    {res.GESTAO_STATUS}
                  </div>
                </div>

                {this.filters.type.map((item, index) => {
                  // qtd padrão vindo do agregado do backend
                  let qtdBase = (this.state.filters.type.find(a => a.value === item.value) || {}).qtd || 0;

                  // se for o filtro "serviceOrder", soma também os "budgeted" já vinculados à OS/OSJ
                  let extraBudgetedVinculados = 0;
                  if (item.value === 'serviceOrder') {
                    const list = Array.isArray(this.state.jobList) ? this.state.jobList : [];
                    extraBudgetedVinculados = list.reduce((acc, it) => {
                      if (
                        it &&
                        it.type === 'budgeted' &&
                        Number(it.id_service_order) > 0 &&
                        Number(it.id_service_order_job) > 0
                      ) return acc + 1;
                      return acc;
                    }, 0);
                  }

                  const qtd = qtdBase + extraBudgetedVinculados;

                  return (
                    <div key={index + "_divtt"} style={{ display: 'flex', height: '2rem' }}>
                      <ListItem
                        key={index + 'tt'}
                        button
                        className={this.state.tab_type.includes(item.value) ? 'SelItemFull' : ''}
                        disabled={item.disabled}
                        onClick={event => this.setArrJobs('tab_type', item.value)}
                        title={item.label}
                      >
                        <ListItemText
                          id={index}
                          primary={`${item.label} (${qtd})`}
                          style={{ textAlign: 'center' }}
                        />
                      </ListItem>
                    </div>
                  );
                })}

                <div className="divider" style={{ marginTop: '1rem' }}></div>
                <div className="divider" style={{ marginTop: '.5rem', position: 'relative', textAlign: 'center' }}>
                  <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '-1.2rem', width: 'fit-content', backgroundColor: 'white', padding: '0 .5rem', fontWeight: 'bold' }}>
                    {res.FILTRO_OPERACAO}
                  </div>
                </div>

                {this.filters.state
                  .filter(item => (!item.invisible))
                  .map((item, index) =>
                    <div key={index + "_divpa"} style={{ display: 'flex', height: '2rem' }}>
                      <ListItem key={index + 'pa1'} button
                        className={this.state.tab_state.includes(item.value) ? 'SelItemFull' : ''}
                        disabled={item.disabled}
                        onClick={event => this.setArrJobs('tab_state', item.value)}
                        title={item.label}
                      >
                        <ListItemText id={index} primary={item.label} style={{ textAlign: 'center' }} />
                      </ListItem>
                    </div>
                  )}

                <div className="divider" style={{ marginTop: '1rem' }}></div>

                {this.filters.missing
                  .filter(item => (!item.invisible))
                  .map((item, index) => {
                    let qtd = this.state.filters.missing.filter(a => (a.value === item.link))[0].qtd;
                    return <div key={index + "_divpa"} style={{ display: 'flex' }}>
                      <ListItem key={index + 'pa1'} button
                        className={this.state.tab_missing.includes(item.value) ? 'SelItem' : ''}
                        disabled={item.disabled}
                        onClick={event => this.setArrJobs('tab_missing', item.value)}
                        title={item.title}
                      >
                        <ListItemText id={index} primary={item.label} />
                        <div style={{ width: '2.8rem', height: '2.8rem', borderRadius: '50%' }}>
                          <GraphPer label={`${qtd}%`} value={qtd} />
                        </div>
                      </ListItem>

                    </div>
                  })}
              </List>
            </div>
            <div
              id="load"
              ref={this.scrollerRef}
              onScroll={this.handleScroll}
              style={{
                margin: '0rem 1rem -1rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                overflow: 'auto',
                height: 'calc(100vh - 0.7rem)',
              }}
            >
              {this.state.bulkSendMode &&
                <div className="divContent" style={{ margin: '0', padding: '.55rem 1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', position: 'sticky', top: 0, zIndex: 10 }}>
                  <div>
                    <b>{res.ENVIAR_PLANEJAMENTO_AERONAVE}:</b> {this.state.selectedBulkPlans.length}
                    <div style={{ fontSize: '.8rem', color: '#00000099', marginTop: '.15rem' }}>
                      {res.SELECIONAR_PLANEJAMENTOS_ENVIO}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '.5rem' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={this.state.selectedBulkPlans.length === 0}
                      onClick={this.openBulkSendPlanes}
                    >
                      {res.ENVIAR}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={this.cancelBulkSendMode}
                    >
                      {res.CANCELAR}
                    </Button>
                  </div>
                </div>
              }
              {this.state.selected && <div>{this.CompJob(0, this.state.selected)}</div>}

              {this.state.jobList && Object.entries(this.groupByDay(this.state.jobList))
                .sort(([dayA], [dayB]) => new Date(dayB) - new Date(dayA))
                .map(([day, items]) => (
                  <div key={day}>
                    <h3
                      style={{
                        marginBottom: '1rem',
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {Moment(day).format(res.FORMAT_DATA)}
                    </h3>
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '1rem',
                        paddingBottom: '1rem',
                        borderBottom: '1px solid lightgray',
                      }}
                    >
                      {items
                        .sort((a, b) => b.rawDate - a.rawDate)
                        .filter(
                          (item) =>
                            !this.state.selected || item.id !== this.state.selected.id
                        )
                        .map((item, index) => this.CompJob(index, item))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <Dialog onClose={this.onCloseEditMap} fullWidth={true} maxWidth={this.state.typeWindow === 'edit' ? 'lg' : 'xl'} aria-labelledby="simple-dialog-title" open={this.state.showForm}>
            {this.state.typeWindow === 'edit' ?
              <MapItem link={link} res={res} idJob={this.state.idPopUp} itensAval={this.state.itensAval} onClose={this.onCloseEditMap}></MapItem>
              :
              <MapPoly link={link} res={res} itensPlan={this.state.itensPlan} itensExe={this.state.itensExe} itensAval={this.state.itensAval} idJob={this.state.idPopUp} changeView={this.changeView} onClose={this.onCloseEditMap}></MapPoly>
            }
          </Dialog>

          <Dialog
            onClose={this.closeOnlineFarmMap3D}
            fullScreen={true}
            aria-labelledby="online-farm-map-3d-title"
            open={this.state.showOnlineFarmMap3D}
            PaperProps={{ style: { margin: 0, maxWidth: '100%', maxHeight: '100%', width: '100%', height: '100%', backgroundColor: '#111' } }}
          >
            <Map3D
              res={res}
              jobs={this.state.onlineFarmMapJobs}
              planes={this.state.onlineFarmMapPlanes}
              planeCatalog={this.state.onlineFarmMapPlaneCatalog}
              dateIni={this.state.onlineFarmMapDateIni || this.state.dateIni}
              dateEnd={this.state.onlineFarmMapDateEnd || this.state.dateEnd}
              onClose={this.closeOnlineFarmMap3D}
            />
          </Dialog>

          <Dialog
            open={!!this.state.newTitle}
            onClose={() => this.setState({ newTitle: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {res.EDITAR}
              {/* <TextField
                margin="normal"
                label={res.TITULO_ATUAL}
                value={this.state.newTitle ? this.state.newTitle.atual : ''}
                id="oldTitle"
                disabled
                fullWidth
              /> */}
              <TextField
                margin="normal"
                label={res.NOVO_TITULO}
                value={this.state.newTitle ? this.state.newTitle.novo : ''}
                onChange={event => {
                  this.state.newTitle.novo = event.target.value
                  this.setState({ newTitle: this.state.newTitle });
                }}
                fullWidth
                onKeyDown={e => {
                  if (e.keyCode === 13) { if (this.state.newTitle) this.state.newTitle.call() }
                }}
                id="newTitle"
                autoComplete="off"
              />
              <div style={{ position: 'relative', marginTop: '1rem' }}>
                <div style={{ fontSize: '.75rem', color: '#757575', marginBottom: '.2rem' }}>{res.CLIENTE}</div>
                <Select
                  margin="normal"
                  value={this.state.newTitle ? this.state.newTitle.client : ''}
                  onChange={event => {
                    this.state.newTitle.client = event.target.value;
                    this.setState({ newTitle: this.state.newTitle });
                  }}
                  displayEmpty
                  fullWidth
                  style={{ paddingRight: '2rem' }}
                >
                  <MenuItem value="" disabled>{res.SELECIONE}</MenuItem>
                  {this.state.customers.map((item, key) => (
                    <MenuItem key={key + 'client'} value={String(item.id)}>{item.name}</MenuItem>
                  ))}
                </Select>
                {this.state.newTitle && this.state.newTitle.client !== '' &&
                  <IconButton style={{ position: 'absolute', padding: '0', top: '1.6rem', right: '1.8rem' }} onClick={() => {
                    this.state.newTitle.client = '';
                    this.setState({ newTitle: this.state.newTitle });
                  }}>
                    <MaterialIcon icon="clear" />
                  </IconButton>
                }
              </div>
              <div style={{ position: 'relative', marginTop: '1rem' }}>
                <div style={{ fontSize: '.75rem', color: '#757575', marginBottom: '.2rem' }}>{res.AERONAVE}</div>
                <Select
                  margin="normal"
                  value={this.state.newTitle ? this.state.newTitle.plane : ''}
                  onChange={event => {
                    this.state.newTitle.plane = event.target.value;
                    this.setState({ newTitle: this.state.newTitle });
                  }}
                  displayEmpty
                  fullWidth
                  style={{ paddingRight: '2rem' }}
                >
                  <MenuItem value="" disabled>{res.SELECIONE}</MenuItem>
                  {this.state.editPlanes.map((item, key) => (
                    <MenuItem key={key + 'plane'} value={String(item.id)}>{item.name}</MenuItem>
                  ))}
                </Select>
                {this.state.newTitle && this.state.newTitle.plane !== '' &&
                  <IconButton style={{ position: 'absolute', padding: '0', top: '1.6rem', right: '1.8rem' }} onClick={() => {
                    this.state.newTitle.plane = '';
                    this.setState({ newTitle: this.state.newTitle });
                  }}>
                    <MaterialIcon icon="clear" />
                  </IconButton>
                }
              </div>
              <div style={{ position: 'relative', marginTop: '1rem' }}>
                <div style={{ fontSize: '.75rem', color: '#757575', marginBottom: '.2rem' }}>{res.PILOTO}</div>
                <Select
                  margin="normal"
                  value={this.state.newTitle ? this.state.newTitle.pilot : ''}
                  onChange={event => {
                    this.state.newTitle.pilot = event.target.value;
                    this.setState({ newTitle: this.state.newTitle });
                  }}
                  displayEmpty
                  fullWidth
                  style={{ paddingRight: '2rem' }}
                >
                  <MenuItem value="" disabled>{res.SELECIONE}</MenuItem>
                  {this.state.editPilots.map((item, key) => (
                    <MenuItem key={key + 'pilot'} value={String(item.id)}>{item.name}</MenuItem>
                  ))}
                </Select>
                {this.state.newTitle && this.state.newTitle.pilot !== '' &&
                  <IconButton style={{ position: 'absolute', padding: '0', top: '1.6rem', right: '1.8rem' }} onClick={() => {
                    this.state.newTitle.pilot = '';
                    this.setState({ newTitle: this.state.newTitle });
                  }}>
                    <MaterialIcon icon="clear" />
                  </IconButton>
                }
              </div>
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => { if (this.state.newTitle) this.state.newTitle.call() }} color="primary">
                {res.CONFIRMAR}
              </Button>
              <Button onClick={() => this.setState({ newTitle: false })} color="primary" autoFocus>
                {res.CANCELAR}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={!!this.state.newFunc}
            onClose={() => this.setState({ newFunc: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {this.newItem.msg}
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => this.newItem.func()} color="primary">
                {res.SIM}
              </Button>
              <Button onClick={() => this.setState({ newFunc: false })} color="primary" autoFocus>
                {res.NAO}
              </Button>
            </DialogActions>
          </Dialog>

          {this.state.bulkPlanAnchorEl && this.state.bulkPlanJob ?
            <MenuList
              className="popup-list"
              anchorEl={this.state.bulkPlanAnchorEl}
              open={Boolean(this.state.bulkPlanAnchorEl)}
              onClose={this.closeBulkPlanSelector}
            >
              <DialogTitle id="alert-dialog-title" style={{ borderBottom: '1px solid #00000026' }}>
                {res.PLANEJAMENTO || 'Planejamentos'}
              </DialogTitle>
              {this.getBulkPlansFromJob(this.state.bulkPlanJob).map((item, key) => (
                <MenuItem
                  key={key + 'bulkPlanSelector'}
                  onClick={() => { this.toggleBulkPlan(this.state.bulkPlanJob, item); }}
                  className="popup-item"
                  style={{ minWidth: '16rem', display: 'grid', gridTemplateColumns: '2.8rem auto', justifyItems: 'start', alignItems: 'center', position: 'relative' }}
                >
                  <Checkbox checked={this.isBulkPlanSelected(item.guid)} />
                  <span style={{ height: '1.6rem' }}>
                    {item.title ? item.title : item.status_task === 'waiting' ? res.AGRARDANDO_CONFIGURACAO : res.PROCESSANDO_}
                  </span>
                  <span style={{ position: 'absolute', right: '.5rem', bottom: '0', fontSize: 'smaller', color: '#00000082' }}>
                    {item.datetime ? Moment(new Date(item.datetime)).format(res.FORMAT_DATAHORAMIN) : item.created_task ? Moment(new Date(item.created_task)).format(res.FORMAT_DATAHORAMIN) : null}
                  </span>
                </MenuItem>
              ))}
              <DialogActions>
                <Button onClick={this.closeBulkPlanSelector} color="primary" autoFocus>
                  {res.CONFIRMAR || res.FECHAR || 'OK'}
                </Button>
              </DialogActions>
            </MenuList> :
            this.state.menuItemList.length > 0 ?
              <MenuList
                className="popup-list"
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleClose}
              >
                <DialogTitle id="alert-dialog-title" style={{ borderBottom: '1px solid #00000026' }}>
                  {res.TRABALHOS}
                </DialogTitle>
                {this.state.menuItemList
                  .map((item, key) => (
                    <MenuItem key={key + 'pl'} onClick={e => {
                      if (item.type === 'planejamento' && this.state.action === 'download') {
                        this.downloadJobPl(item.id, item.title);
                      } else {
                        this.listSendPlanes(this.state.menuItem, item);
                      }
                    }} className="popup-item">
                      <span style={{ height: '1.6rem' }}>
                        {item.title ? item.title : item.status_task === 'waiting' ? res.AGRARDANDO_CONFIGURACAO : res.PROCESSANDO_}
                      </span>
                      <span style={{ position: 'absolute', right: '.5rem', bottom: '0', fontSize: 'smaller', color: '#00000082' }}>
                        {item.datetime ? Moment(new Date(item.datetime)).format(res.FORMAT_DATAHORAMIN) : item.created_task ? Moment(new Date(item.created_task)).format(res.FORMAT_DATAHORAMIN) : null}
                      </span>
                    </MenuItem>
                  ))}
              </MenuList> :
              this.state.openListPlanes ?
                <MenuList
                  className="popup-list"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl)}
                  onClose={this.handleClose}
                >
                  <DialogTitle id="alert-dialog-title" style={{ borderBottom: '1px solid #00000026' }}>
                    {this.compartilhar ? res.CLIENTES : res.AERONAVES}
                    {this.state.bulkSendMode && !this.compartilhar ?
                      <div style={{ fontSize: '.8rem', fontWeight: 'normal', color: '#00000099' }}>
                        {this.state.selectedBulkPlans.length} planejamento(s) selecionado(s)
                      </div> : null}
                  </DialogTitle>
                  {this.state.bulkSendMode && !this.compartilhar ?
                    <div style={{ maxHeight: '12rem', overflowY: 'auto', borderBottom: '1px solid #00000012' }}>
                      <div style={{ padding: '.5rem 1rem .25rem', fontSize: '.75rem', fontWeight: 'bold', color: '#00000099' }}>
                        {res.PLANEJAMENTOS_SELECIONADOS}
                      </div>
                      {this.state.selectedBulkPlans.map((item, key) => (
                        <MenuItem key={key + 'bulkPlan'} className="popup-item" style={{ pointerEvents: 'none', opacity: 0.85, position: 'relative' }}>
                          <span style={{ height: '1.6rem' }}>
                            {item.title ? item.title : res.PLANEJAMENTO}
                          </span>
                          <span style={{ position: 'absolute', right: '.5rem', bottom: '0', fontSize: 'smaller', color: '#00000082' }}>
                            {item.datetime ? Moment(new Date(item.datetime)).format(res.FORMAT_DATAHORAMIN) : null}
                          </span>
                        </MenuItem>
                      ))}
                    </div> : null}
                  {this.compartilhar ?
                    this.state.clients
                      //.filter(item => item.id_dgps)
                      .map((item, key) => (
                        <MenuItem key={key + 'pl'} onClick={() => { this.selectSendClients(item.id) }} className="popup-item" style={{ minWidth: '10rem', display: 'grid', gridTemplateColumns: '3rem auto', justifyItems: 'center' }}>
                          <Checkbox
                            checked={this.state.selectedSendClients.indexOf(item.id) > -1}
                          />
                          {item.client_name}
                        </MenuItem>
                      )) :
                    this.state.planes
                      .filter(item => item.id_dgps)
                      .map((item, key) => (
                        <MenuItem key={key + 'pl'} onClick={() => { this.selectSendPlanes(item.id) }} className="popup-item" style={{ minWidth: '10rem', display: 'grid', gridTemplateColumns: '3rem auto', justifyItems: 'center' }}>
                          <Checkbox
                            checked={this.state.selectedSendPlanes.indexOf(item.id) > -1}
                          />
                          {item.name}
                        </MenuItem>
                      ))}
                  <DialogActions>
                    <Button type="submit" disabled={this.state.selectedSendPlanes.length === 0 && this.state.selectedSendClients.length === 0} variant="contained" color={"primary"}
                      onClick={e => { this.sendFile() }}>
                      {res.ENVIAR}
                    </Button>
                  </DialogActions>
                </MenuList>
                : <MenuList
                  className="popup-list"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl)}
                  onClose={this.handleClose}
                >
                  {this.state.menuItem && this.state.menuItem.jl_sk === 0 && this.state.menuItem.jl_pl > 0 && this.state.planes.filter(item => item.id_dgps).length > 0 && (this.state.menuItem.type !== this.filters.type[3].value && this.state.menuItem.type !== this.filters.type[4].value) ?
                    <MenuItem onClick={(e) => { this.compartilhar = false; this.handleClickList(e, this.state.menuItem, this.state.menuItem.list_plan); }} className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <SvgIcon viewBox="0 96 960 960" style={{ width: '1.7rem', height: '1.7rem' }}>
                        <path d="M253.308 875.999q-80.877 0-137.092-56.562-56.214-56.562-56.214-137.13 0-74.384 49.538-129.614 49.538-55.231 122.461-62.23 11.923-81.693 77.577-145.039 65.653-63.346 148.346-63.346 18.23 0 31.807 10.423 13.576 10.423 13.576 27.653v304.77l87.231-87.615 32.615 32.999-142.538 142.153-142.152-142.153 32.614-32.999 86.847 87.615V324q-82.923 6.385-135.193 70.692Q270.462 459 270.462 534.385h-19.385q-60.044 0-102.868 42.615t-42.824 105.692q0 63.077 43.846 105.5t104.183 42.423h494.509q44.231 0 75.461-31.293 31.231-31.293 31.231-75.269 0-43.976-31.231-75.207-31.23-31.231-75.597-31.231h-62.095v-83.23q0-63-29.923-110.384-29.923-47.385-77.691-75.616v-49.999q70.614 28.616 111.806 93.308 41.192 64.691 41.192 142.691v37.847h12.308q65.461-2.385 111.038 40.999 45.577 43.385 45.577 110.692 0 62.461-44.808 107.268-44.807 44.808-107.268 44.808H253.308ZM480 555.539Z" />
                      </SvgIcon>
                      {res.ENVIAR_PLANEJAMENTO}
                    </MenuItem>
                    : this.state.menuItem && this.state.menuItem.jl_sk > 0 && this.state.planes.filter(item => item.id_dgps).length > 0 && (this.state.menuItem.type !== this.filters.type[3].value && this.state.menuItem.type !== this.filters.type[4].value) &&
                    <MenuItem onClick={(e) => { this.compartilhar = false; this.handleClickList(e, this.state.menuItem, this.state.menuItem.list_exe); }} className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <SvgIcon viewBox="0 96 960 960" style={{ width: '1.7rem', height: '1.7rem' }}>
                        <path d="M253.308 875.999q-80.877 0-137.092-56.562-56.214-56.562-56.214-137.13 0-74.384 49.538-129.614 49.538-55.231 122.461-62.23 11.923-81.693 77.577-145.039 65.653-63.346 148.346-63.346 18.23 0 31.807 10.423 13.576 10.423 13.576 27.653v304.77l87.231-87.615 32.615 32.999-142.538 142.153-142.152-142.153 32.614-32.999 86.847 87.615V324q-82.923 6.385-135.193 70.692Q270.462 459 270.462 534.385h-19.385q-60.044 0-102.868 42.615t-42.824 105.692q0 63.077 43.846 105.5t104.183 42.423h494.509q44.231 0 75.461-31.293 31.231-31.293 31.231-75.269 0-43.976-31.231-75.207-31.23-31.231-75.597-31.231h-62.095v-83.23q0-63-29.923-110.384-29.923-47.385-77.691-75.616v-49.999q70.614 28.616 111.806 93.308 41.192 64.691 41.192 142.691v37.847h12.308q65.461-2.385 111.038 40.999 45.577 43.385 45.577 110.692 0 62.461-44.808 107.268-44.807 44.808-107.268 44.808H253.308ZM480 555.539Z" />
                      </SvgIcon>
                      {res.ENVIAR_TRABALHO}
                    </MenuItem>
                  }
                  {this.state.menuItem && this.state.menuItem.jl_sk > 0 && this.state.clients && this.state.clients.length > 0 &&
                    <MenuItem onClick={(e) => { this.compartilhar = true; this.handleClickList(e, this.state.menuItem, this.state.menuItem.list_exe); }} className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <MaterialIcon icon="share" style={{ marginTop: '.3rem', marginRight: '.2rem' }} />
                      {res.COMPARTILHAR_TRABALHO}
                    </MenuItem>
                  }
                  {this.state.selected ?
                    this.state.selected !== this.state.menuItem ?
                      this.state.selected.id_service_order && this.state.menuItem.id_service_order ? null :
                        <MenuItem disabled={(this.state.selected.jl_sk > 0 && this.state.menuItem.jl_sk > 0)}
                          onClick={e => { this.mergeItem(this.state.menuItem); }}
                          className="popup-item" title={(this.state.selected.jl_sk > 0 && this.state.menuItem.jl_sk > 0) && res.EXECUCOES_NAO_JUNTAR} style={{ pointerEvents: 'auto' }}>
                          <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={{ marginLeft: '.5rem', marginRight: '.6rem' }} >
                            <path id="polygon" d="M 99 19 L 99 39 L 78 39 L 78 19 z M 97 34 L 99 34 L 99 30 L 97 30 L 97 28 L 99 28 L 99 24 L 97 24 L 97 21 L 94 21 L 94 19 L 90 19 L 90 21 L 87 21 L 87 19 L 83 19 L 83 21 L 80 21 L 80 24 L 78 24 L 78 28 L 80 28 L 80 30 L 78 30 L 78 34 L 80 34 L 80 37 L 83 37 L 83 39 L 87 39 L 87 37 L 90 37 L 90 39 L 94 39 L 94 37 L 97 37 z" />
                          </SvgIcon>
                          {res.JUNTAR_SELECIONADO}
                        </MenuItem>
                      :
                      <MenuItem onClick={e => { this.handleClose(e); this.setState({ selected: null }); }} className="popup-item">
                        <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={{ marginLeft: '.5rem', marginRight: '.6rem' }} >
                          <path id="polygon" d="M 99 19 L 99 39 L 78 39 L 78 19 z M 97 34 L 99 34 L 99 30 L 97 30 L 97 28 L 99 28 L 99 24 L 97 24 L 97 21 L 94 21 L 94 19 L 90 19 L 90 21 L 87 21 L 87 19 L 83 19 L 83 21 L 80 21 L 80 24 L 78 24 L 78 28 L 80 28 L 80 30 L 78 30 L 78 34 L 80 34 L 80 37 L 83 37 L 83 39 L 87 39 L 87 37 L 90 37 L 90 39 L 94 39 L 94 37 L 97 37 z" />
                        </SvgIcon>
                        {res.REMOVER_SELECIONADO}
                      </MenuItem>
                    :
                    <MenuItem onClick={e => { this.handleClose(e); this.selectItem(this.state.menuItem); }} className="popup-item">
                      <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={{ marginLeft: '.5rem', marginRight: '.6rem' }} >
                        <path id="polygon" d="M 99 19 L 99 39 L 78 39 L 78 19 z M 97 34 L 99 34 L 99 30 L 97 30 L 97 28 L 99 28 L 99 24 L 97 24 L 97 21 L 94 21 L 94 19 L 90 19 L 90 21 L 87 21 L 87 19 L 83 19 L 83 21 L 80 21 L 80 24 L 78 24 L 78 28 L 80 28 L 80 30 L 78 30 L 78 34 L 80 34 L 80 37 L 83 37 L 83 39 L 87 39 L 87 37 L 90 37 L 90 39 L 94 39 L 94 37 L 97 37 z" />
                      </SvgIcon>
                      {res.SELECIONAR}
                    </MenuItem>
                  }
                  {(!this.state.menuItem || !this.state.menuItem.jl_pl > 0) &&
                    <MenuItem onClick={event => {
                      if (this.state.menuItem.list_plan.length > 0)
                        this.props.link('/app/estimativa/edit/' + this.state.menuItem.list_plan[0].guid);
                      else
                        this.props.link('/app/estimativa/new/' + this.state.menuItem.guid);
                      this.handleClose(event);
                    }
                    } className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <SvgIcon viewBox="-2 0 26 26" style={{ width: '1.7rem', height: '1.7rem', marginRight: '.6rem' }}>
                        <path d="M2.5,19h19v2h-19V19z M22.07,9.64c-0.21-0.8-1.04-1.28-1.84-1.06L14.92,10l-6.9-6.43L6.09,4.08l4.14,7.17l-4.97,1.33 l-1.97-1.54l-1.45,0.39l2.59,4.49c0,0,7.12-1.9,16.57-4.43C21.81,11.26,22.28,10.44,22.07,9.64z" />
                      </SvgIcon>
                      {res.PLANEJAR}
                    </MenuItem>
                  }
                  {this.state.menuItem && this.state.menuItem.jl_pl > 0 &&
                    <MenuItem onClick={e => { this.compartilhar = false; this.handleClickList(e, this.state.menuItem, this.state.menuItem.list_plan, 'download'); }} className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <MaterialIcon icon="download" style={{ marginTop: '.3rem', marginRight: '.2rem' }} />
                      {res.BAIXAR_PLANEJAMENTO}
                    </MenuItem>
                  }
                  {this.state.menuItem && this.state.menuItem.jl_sk > 0 &&
                    <MenuItem onClick={event => { this.downloadJob(this.state.menuItem.id); }} className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <MaterialIcon icon="download" style={{ marginTop: '.3rem', marginRight: '.2rem' }} />
                      {res.BAIXAR_TRABALHO_PARCIAL}
                    </MenuItem>
                  }
                  {this.state.menuItem && this.state.menuItem.jl_sk > 0 &&
                    <MenuItem onClick={event => {
                      const exportJob = this.state.menuItem;
                      this.handleClose(event);
                      if (this.jobApplicationReportModalRef.current) {
                        this.jobApplicationReportModalRef.current.open(exportJob);
                      }
                    }} className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <MaterialIcon icon="picture_as_pdf" style={{ marginTop: '.3rem', marginRight: '.2rem' }} />
                      {res.RELATORIO_APLICACAO}
                    </MenuItem>
                  }
                  {this.state.menuItem && this.state.menuItem.jl_sk > 0 &&
                    <MenuItem onClick={event => {
                      const exportJob = this.state.menuItem;
                      this.handleClose(event);
                      if (this.jobApplicationKmzModalRef.current) {
                        this.jobApplicationKmzModalRef.current.open(exportJob);
                      }
                    }} className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="0 0 541 541">
                        <path class="fil0" d="M419.32 190.36l0 159.3 -24.51 0 0 -159.3 -49.01 0c-20.31,0 -36.77,-16.46 -36.77,-36.76l0 -49.02 -134.79 0c-13.53,0 -24.5,10.97 -24.5,24.51l0 220.57 -24.52 0 0 -220.57c0.01,-27.07 21.96,-49.02 49.03,-49.02l134.78 0 110.29 110.29z" />
                        <path class="fil1" d="M144.72 462.41l0 -89.86 18.54 0 0 39.81 37.35 -39.81 24.82 0 -34.52 35 36.32 54.86 -23.9 0 -25.19 -42.19 -14.88 15.02 0 27.17 -18.54 0zm91.8 0l0 -89.86 27.76 0 16.4 61.28 16.21 -61.28 27.82 0 0 89.86 -17.12 0 -0.07 -70.74 -18.04 70.74 -17.81 0 -17.96 -70.74 -0.07 70.74 -17.12 0zm98.68 0l0 -16.32 48.22 -58.35 -42.73 0 0 -15.19 66.98 0 0 14.06 -50.11 60.61 52.02 0 0 15.19 -74.38 0z" />
                        <path class="fil0" d="M283.54 229.95c0,-6.23 -5.05,-11.28 -11.28,-11.28 -6.23,0 -11.28,5.05 -11.28,11.28l0 85.62 -25.88 -25.89c-2.1,-2.12 -4.99,-3.32 -7.98,-3.32 -6.25,0 -11.31,5.06 -11.31,11.31 0,2.99 1.2,5.87 3.31,7.99l45.15 45.15c2.12,2.11 5,3.31 7.99,3.31 2.99,0 5.87,-1.2 7.99,-3.32l45.15 -45.15c2.11,-2.11 3.31,-4.99 3.31,-7.98 0,-6.25 -5.06,-11.31 -11.31,-11.31 -2.99,0 -5.88,1.2 -7.99,3.31l-25.87 25.9 0 -85.62z" />
                      </svg>
                      KMZ
                    </MenuItem>
                  }
                  {this.state.menuItem &&
                    <MenuItem onClick={event => {
                      this.updateTitleTrabalho(this.state.menuItem.id, this.state.menuItem.title);
                    }
                    } className="popup-item" style={{ display: 'grid', gridTemplateColumns: '2.3rem auto', justifyItems: 'center' }}>
                      <SvgIcon viewBox="-80 -900 900 900" style={{ width: '1.7rem', height: '1.7rem', marginRight: '.6rem' }}>
                        <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
                      </SvgIcon>
                      {res.EDITAR}
                    </MenuItem>
                  }
                  {this.state.menuItem && this.state.menuItem.status !== 'canceled' ?
                    <MenuItem onClick={e => { this.handleClose(e); this.updateStatusTrabalho(this.state.menuItem.id, 'canceled', null, this.state.menuItem.stage); }} className="popup-item">
                      <MaterialIcon style={{ fontSize: '20px', marginLeft: '6px', marginRight: '6px' }} icon="delete_outline" className="iconS icon-pos" />
                      {res.EXCLUIR_TRABALHO}
                    </MenuItem> :
                    <MenuItem onClick={e => { this.handleClose(e); this.updateStatusTrabalho(this.state.menuItem.id, 'private', null, this.state.menuItem.stage); }} className="popup-item">
                      <SvgIcon viewBox="-80 -900 900 900" style={{ width: '1.7rem', height: '1.7rem', marginRight: '.6rem' }}>
                        <path d="M460-347.692h40V-535.23l84 83.538L612.308-480 480-612.308 347.692-480 376-451.692l84-83.538v187.538ZM304.615-160Q277-160 258.5-178.5 240-197 240-224.615V-720h-40v-40h160v-30.77h240V-760h160v40h-40v495.385Q720-197 701.5-178.5 683-160 655.385-160h-350.77ZM680-720H280v495.385q0 9.23 7.692 16.923Q295.385-200 304.615-200h350.77q9.23 0 16.923-7.692Q680-215.385 680-224.615V-720Zm-400 0v520-520Z" />
                      </SvgIcon>
                      {res.RESTAURAR_TRABALHO}
                    </MenuItem>
                  }
                  {this.state.menuItem && this.state.menuItem.status === 'canceled' &&
                    <MenuItem onClick={e => { this.handleClose(e); this.updateStatusTrabalho(this.state.menuItem.id, 'deleted', null, this.state.menuItem.stage); }} className="popup-item">
                      <MaterialIcon style={{ fontSize: '20px', marginLeft: '6px', marginRight: '6px' }} icon="delete_forever_outlined" className="iconS icon-pos" />
                      {res.EXCLUIR_TRABALHO}
                    </MenuItem>
                  }
                </MenuList>
          }

          <MenuList
            className="popup-list"
            anchorEl={this.state.anchorElAdd}
            open={Boolean(this.state.anchorElAdd)}
            onClose={e => { this.handleCloseAdd('anchorElAdd') }}
          >
            <div style={{ width: '11rem', height: '5rem', textAlign: 'center' }}>
              <p>Zoom: </p>
              < Button className={true ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.zoom <= .5} onClick={event => this.changeZoom(-.1)}>
                <SvgIcon viewBox="0 -960 960 960" className="iconMapP" style={{ color: this.state.zoom <= .5 ? '#b9b9b9' : 'black' }} >
                  <path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm384-16v-80h320v80H600Z" />
                </SvgIcon>
              </Button>
              <label style={{ margin: '.2rem' }}>  {(this.state.zoom * 100).toFixed()}%  </label>
              < Button className={this.state.create ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.zoom >= 1.5} onClick={event => this.changeZoom(.1)}>
                <SvgIcon viewBox="0 -960 960 960" className="iconMapP" style={{ color: this.state.zoom >= 1.5 ? '#b9b9b9' : 'black' }} >
                  <path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm504 104v-120H600v-80h120v-120h80v120h120v80H800v120h-80Z" />
                </SvgIcon>
              </Button>
            </div>
          </MenuList>


          <MenuList
            className="popup-list"
            anchorEl={this.state.anchorElType}
            open={Boolean(this.state.anchorElType)}
            onClose={e => { this.handleCloseAdd('anchorElType') }}
          >
            {this.filters.type
              .map((item, key) => (
                <MenuItem key={key + 'pl'} onClick={e => { this.handleCloseAdd('anchorElType'); this.updateStatusTrabalho(this.state.menuItem.id, item.value, 'type'); }} className="popup-item">
                  {item.label}
                </MenuItem>
              ))}
          </MenuList>

          <MenuList
            className="popup-list"
            anchorEl={this.state.anchorElItem}
            open={Boolean(this.state.anchorElItem)}
            onClose={e => { this.handleCloseAdd('anchorElItem') }}
          >
            {this.state.url && this.state.url.newUrl &&
              <MenuItem key={'pl0'} onClick={() => { this.handleCloseAdd('anchorElItem'); this.openProcess(this.state.url.viewUrl, this.state.menuItem.guid); }}
                className="popup-item" style={{ minWidth: '10rem', display: 'grid', gridTemplateColumns: '3rem auto', justifyItems: 'center' }}>
                <AddIcon />
                {res.CRIAR_NOVO}
              </MenuItem>
            }
            {this.state.menuItemList
              .map((item, key) => {
                return <MenuItem key={key + 'pl'} onClick={() => { if (clickOut) { clickOut = false; return; } this.handleCloseAdd('anchorElItem'); this.openProcess(this.state.url.viewUrl, item.guid, 100); }} className="popup-item">
                  <span style={{ height: '1.6rem', minWidth: '7rem', textAlign: 'left', width: '100%' }}>
                    {item.status_task === 'finished' || !item.status_task ? item.title ? item.title : " - Sem Título" : item.status_task === 'waiting' ? res.AGRARDANDO_CONFIGURACAO : res.PROCESSANDO_}
                  </span>
                  <span style={{ position: 'absolute', left: '3.4rem', bottom: '0', fontSize: 'smaller', color: '#00000082' }}>
                    {item.datetime ? Moment(new Date(item.datetime)).format(res.FORMAT_DATAHORAMIN) : item.created_task ? Moment(new Date(item.created_task)).format(res.FORMAT_DATAHORAMIN) : null}
                  </span>
                  {this.state.url && this.state.url.newUrl && <>
                    <IconButton onClick={() => { clickOut = true; this.updateStatusTrabalho(item.id, 'canceled', 'link'); }} size='small' aria-label="delete" style={{ marginLeft: '.5rem' }}>
                      <DeleteIcon style={{ scale: '.9' }} />
                    </IconButton>
                    {profile && profile.includes(1) &&
                      <IconButton onClick={() => { clickOut = true; this.runAI(item.guid); }} size='small' aria-label="delete" style={{ marginLeft: '.5rem' }}>
                        <FaceIcon style={{ scale: '.9' }} />
                      </IconButton>
                    }</>
                  }
                </MenuItem>
              })}
          </MenuList>

          <MenuList
            anchorEl={this.state.anchorElSO}
            open={Boolean(this.state.anchorElSO)}
            onClose={this.closeServiceOrderMenu}
            keepMounted
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            marginThreshold={0}
            PaperProps={{ style: { maxHeight: '40vh', overflowY: 'auto', minWidth: 260 } }}
            MenuListProps={{ dense: true }}
          >
            {this.state.soLoading ? (
              <MenuItem disabled style={{ justifyContent: 'center' }}>
                <CircularProgress color="inherit" disableShrink size={28} />
              </MenuItem>
            ) : (
              <>
                {!this.state.soMenuItem || !this.state.soMenuItem.id_service_order ? (
                  <>
                    <MenuItem onClick={() => this.goToCreateSO(this.state.soMenuItem)}>
                      <AddIcon />
                      {res.CRIAR_NOVO}
                    </MenuItem>

                    <MenuItem disableGutters style={{ padding: '8px 12px' }}>
                      <div style={{ width: '100%', display: 'flex' }}>
                        <TextField
                          fullWidth
                          value={this.state.soSearchText || ''}
                          onChange={this.onChangeSoSearch}
                          placeholder={this.props.res.ORDEM_SERVICO}
                          size="small"
                          style={{ marginRight: '0.5rem' }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={this.searchServiceOrders}
                            disabled={!String(this.state.soSearchText || '').trim().length}
                          >
                            {this.props.res.BUSCAR}
                          </Button>
                        </div>
                      </div>
                    </MenuItem>
                  </>
                ) : null}

                {this.state.soList.map((os) => (
                  <MenuItem key={String(os.id)} onClick={() => this.goToExistingSO(os.id)}>
                    <MaterialIcon icon="description" className="iconS icon-pos iconMenu" />
                    {`Nº${(os.order_number !== undefined && os.order_number !== null) ? os.order_number : os.id} - ${os.title ? os.title : ''}`}
                  </MenuItem>
                ))}

                {this.state.soList.length === 0 && (
                  <MenuItem disabled>{this.props.res.SEM_RESULTADO_OS}</MenuItem>
                )}
              </>
            )}
          </MenuList>

          <Popover
            id="mouse-over-popover"
            open={Boolean(this.state.anchorElDate)}
            anchorEl={this.state.anchorElDate}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={this.handlePopClose}
            disableRestoreFocus
          >
            {this.state.menuItem &&
              <div style={{
                fontSize: '12px',
                color: '#5d5d5d',
                padding: '0.5rem',
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
              }}>
                <>
                  <div>
                    <span style={{ fontWeight: 'bold' }}>{this.props.res.CRIADO}:&nbsp;</span>{this.state.menuItem.created ?
                      <span>{Moment(this.state.menuItem.created).format(this.props.res.FORMAT_DATAHORAMINSEG)}</span> : ' - '}
                  </div>
                  <div>
                    <span style={{ fontWeight: 'bold' }}>{res.ATUALIZADO}:&nbsp;</span>{this.state.menuItem.updated ?
                      <span>{Moment(this.state.menuItem.updated).format(this.props.res.FORMAT_DATAHORAMINSEG)}</span> : ' - '}
                  </div>
                  <div>
                    <span style={{ fontWeight: 'bold' }}>{res.INICIO__APLICACAO}:&nbsp;</span>{this.state.menuItem.list_exe.length && this.state.menuItem.list_exe[0].startDate ?
                      <span>{Moment(this.state.menuItem.list_exe[0].startDate).format(this.props.res.FORMAT_DATAHORAMINSEG)}</span> : ' - '}
                  </div>
                  <div>
                    <span style={{ fontWeight: 'bold' }}>{res.FIM__APLICACAO}:&nbsp;</span>{this.state.menuItem.list_exe.length && this.state.menuItem.list_exe[0].endDate ?
                      <span>{Moment(this.state.menuItem.list_exe[0].endDate).format(this.props.res.FORMAT_DATAHORAMINSEG)}</span> : ' - '}
                  </div>
                </>
              </div>
            }
          </Popover>
        </div >
      </ div >
    )
  };
}

const Section = (props) => {
  const { link, res, profile } = props;
  return (
    <EnhancedTable link={link} res={res} profile={profile} />
  )
}

export default Section;
